<template>
  <div class="lists">
    <div class="row not-margin info-user margin-between-section">
      <div class="col-md-6 text-left">
        <h1>{{role}} {{userName}}</h1>
        <p>{{team}}</p>
      </div>
      <div class="col-md-6 text-right">
        <div class="dropdown">
          <button
            class="btn dropdown-toggle btn-d"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >{{ $t('profile.my_list') }}</button>
          <div class="dropdown-menu dropdown-menu-right"  aria-labelledby="dropdownMenuButton">
            <button v-on:click="filterList('')" class="dropdown-item principal-option" href="#"><img src="../assets/images/addStar.png"> {{ $t('profile.my_favorites')}} </button>
            <button v-on:click="filterList(data.name)" v-for="data in data" :key="data.id" class="dropdown-item" href="#">{{data.name}}</button>
          </div>
        </div>
        <button v-on:click="createList" class="btn btn-action-create m-top-margin" href="#">{{ $t('profile.create_list') }}</button>
        
      </div>
    </div>

    <div class="container-info margin-between-section">
      <p v-if="nameList != ''" class="name-list">{{nameList}}</p>
      <table class="table table-condensed container-info tb-header" style="border-collapse:collapse;">
      <thead>
        <tr>
          
          <th>{{ $t('playerTable.player') }}</th>
          <th class="show-desktop">{{ $t('playerTable.position') }}</th>
          <th>{{ $t('playerTable.team') }}</th>
          <th class="show-desktop-d">{{ $t('playerTable.league') }}</th>
          <th>{{ $t('playerTable.age') }}</th>
          <th class="show-desktop">{{ $t('playerTable.birth_country') }}</th>
          <th class="show-desktop-d">{{ $t('playerTable.passport_country') }}</th>
          <th class="show-desktop-d">{{ $t('playerTable.foot') }}</th>
          <th class="show-desktop-d">{{ $t('playerTable.height') }}</th>
          <th class="show-desktop-d">{{ $t('admin.cost') }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody id="accordion">
        <template v-for="(value, index) in list">        
          <tr :key="index" :class="{'done-row': index == selectedUser}" class="accordion-toggle t-border" v-bind:index="index">
            <!--<td><button :class="{done: value.inList == true}" v-on:click="handleSelectItem(value.objectId)" class="add_player border" v-bind:id="value.objectId"></button></td>--->
            <td v-on:click="handleRow(index)" data-toggle="collapse" :data-target="'#detail' + index" >{{value.firstName}} {{value.lastName}}</td>
            <td v-if="$t('flag.flag') == 'es'" v-on:click="handleRow(index)" data-toggle="collapse" :data-target="'#detail' + index">
              <p class="in-p-a" v-for="pos in value.positions" :key="pos.id">
                <span v-if="pos == 'cb'">dfc </span><span v-else-if="pos == 'dfc'">dfc</span>
                <span v-if="pos == 'lb'">li </span><span v-else-if="pos == 'li'">li</span>
                <span v-if="pos == 'rb'">ld </span><span v-else-if="pos == 'ld'">ld </span>
                <span v-if="pos == 'lwb'">cri </span><span v-else-if="pos == 'cri'">cri</span>
                <span v-if="pos == 'rwb'">crd </span><span v-else-if="pos == 'crd'">crd</span>
                <span v-if="pos == 'dm'">md </span><span v-else-if="pos == 'md'">md</span>
                <span v-if="pos == 'lm'">exi </span><span v-else-if="pos == 'exi'">exi</span>
                <span v-if="pos == 'cm'">mc </span><span v-else-if="pos == 'mc'">mc</span>
                <span v-if="pos == 'rm'">exd </span><span v-else-if="pos == 'exd'">exd</span>
                <span v-if="pos == 'am'">mo </span><span v-else-if="pos == 'mo'">mo</span>
                <span v-if="pos == 's'">del </span><span v-else-if="pos == 'del'">del</span>
              </p>
            </td>
            <td v-else v-on:click="handleRow(index)" data-toggle="collapse" :data-target="'#detail' + index">
              <p  class="in-p-a" v-for="pos in value.positions" :key="pos.id">
                <span v-if="pos == 'dfc'">cb </span><span v-else-if="pos == 'cb'">cb </span>
                <span v-if="pos == 'li'">lb </span><span v-else-if="pos == 'lb'">lb </span>
                <span v-if="pos == 'ld'">rb </span><span v-else-if="pos == 'rb'">rb </span>
                <span v-if="pos == 'cri'">lwb </span><span v-else-if="pos == 'lwb'">lwb </span>
                <span v-if="pos == 'crd'">rwb </span><span v-else-if="pos == 'rwb'">rwb</span>
                <span v-if="pos == 'md'">dm </span><span v-else-if="pos == 'dm'">dm </span>
                <span v-if="pos == 'exi'">lm </span><span v-else-if="pos == 'lm'">lm </span>
                <span v-if="pos == 'mc'">cm </span><span v-else-if="pos == 'cm'">cm </span>
                <span v-if="pos == 'exd'">rm </span><span v-else-if="pos == 'rm'">rm </span>
                <span v-if="pos == 'mo'">am </span><span v-else-if="pos == 'am'">am </span>
                <span v-if="pos == 'del'">s </span><span v-else-if="pos == 's'">s </span>
              </p>
            </td>
            <td v-on:click="handleRow(index)" data-toggle="collapse" :data-target="'#detail' + index">{{value.team}}</td>
            <td v-on:click="handleRow(index)" class="show-desktop-d" data-toggle="collapse" :data-target="'#detail' + index">{{value.league}}</td>
            <td v-on:click="handleRow(index)" data-toggle="collapse" :data-target="'#detail' + index">{{ageSet(value.birthday)}}</td>
            <td v-if="$t('flag.flag') == 'es'" v-on:click="handleRow(index)" class="show-desktop-d" data-toggle="collapse" :data-target="'#detail' + index">
              <p><span v-if="value.nationality == 'Afganistan'"> Afganistán </span><span v-else-if="value.nationality == 'Afganistán'">Afganistán </span></p>
              <p><span v-if="value.nationality == 'Albania'"> Albania </span></p>
              <p><span v-if="value.nationality == 'Germany'"> Alemania </span><span v-else-if="value.nationality == 'Alemania'">Alemania </span></p>
              <p><span v-if="value.nationality == 'Angola'"> Angola </span></p>
              <p><span v-if="value.nationality == 'Antigua y Barbuda'"> Antigua y Barbuda </span></p>
              <p><span v-if="value.nationality == 'Saudi Arabia'"> Arabia Saudita </span><span v-else-if="value.nationality == 'Arabia Saudita'">Arabia Saudita </span></p>
              <p><span v-if="value.nationality == 'Algeria'"> Argelia </span><span v-else-if="value.nationality == 'Argelia'">Argelia </span></p>
              <p><span v-if="value.nationality == 'Argentina'"> Argentina </span></p>
              <p><span v-if="value.nationality == 'Armenia'"> Armenia </span></p>
              <p><span v-if="value.nationality == 'Aruba'"> Aruba </span></p>
              <p><span v-if="value.nationality == 'Australia'"> Australia </span></p>
              <p><span v-if="value.nationality == 'Austria'"> Austria </span></p>
              <p><span v-if="value.nationality == 'Azerbaijan'"> Azerbaiyán </span><span v-else-if="value.nationality == 'Azerbaiyán'">Azerbaiyán </span></p>
              <p><span v-if="value.nationality == 'Bahamas'"> Bahamas </span></p>
              <p><span v-if="value.nationality == 'Bangladesh'"> Bangladés </span><span v-else-if="value.nationality == 'Bangladés'">Bangladés </span></p>
              <p><span v-if="value.nationality == 'Barbados'"> Barbados </span></p>
              <p><span v-if="value.nationality == 'Bahrain'"> Baréin </span><span v-else-if="value.nationality == 'Baréin'">Baréin </span></p>
              <p><span v-if="value.nationality == 'Belgium'"> Bélgica </span><span v-else-if="value.nationality == 'Bélgica'">Bélgica </span></p>
              <p><span v-if="value.nationality == 'Belize'"> Belice </span><span v-else-if="value.nationality == 'Belice'">Belice </span></p>
              <p><span v-if="value.nationality == 'Benin'"> Benín </span><span v-else-if="value.nationality == 'Benín'">Benín </span></p>
              <p><span v-if="value.nationality == 'Belarus'"> Bielorrusia </span><span v-else-if="value.nationality == 'Bielorrusia'">Bielorrusia </span></p>
              <p><span v-if="value.nationality == 'Burma'"> Birmania </span><span v-else-if="value.nationality == 'Birmania'">Birmania </span></p>
              <p><span v-if="value.nationality == 'Bolivia'"> Bolivia </span></p>
              <p><span v-if="value.nationality == 'Bosnia and Herzegovina'"> Bosnia and Herzegovina </span></p>
              <p><span v-if="value.nationality == 'Botswana'"> Botsuana </span><span v-else-if="value.nationality == 'Botsuana'">Botsuana </span></p>
              <p><span v-if="value.nationality == 'Brazil'"> Brasil </span><span v-else-if="value.nationality == 'Brasil'">Brasil </span></p>
              <p><span v-if="value.nationality == 'Brunei'"> Brunei </span></p>
              <p><span v-if="value.nationality == 'Bulgaria'"> Bulgaria </span></p>
              <p><span v-if="value.nationality == 'Burkina Faso'"> Burkina Faso </span></p>
              <p><span v-if="value.nationality == 'Burundi'"> Burundi </span></p>
              <p><span v-if="value.nationality == 'Bhutan'"> Bután </span><span v-else-if="value.nationality == 'Bután'">Bután </span></p>
              <p><span v-if="value.nationality == 'Cape Verde'"> Cabo Verde </span><span v-else-if="value.nationality == 'Cabo Verde'">Cabo Verde </span></p>
              <p><span v-if="value.nationality == 'Cambodia'"> Camboya </span><span v-else-if="value.nationality == 'Camboya'">Camboya </span></p>
              <p><span v-if="value.nationality == 'Cameroon'"> Camerún </span><span v-else-if="value.nationality == 'Camerún'">Camerún </span></p>
              <p><span v-if="value.nationality == 'Canada'"> Canadá </span><span v-else-if="value.nationality == 'Canadá'">Canadá </span></p>
              <p><span v-if="value.nationality == 'Qatar'"> Catar </span><span v-else-if="value.nationality == 'Catar'">Catar </span></p>
              <p><span v-if="value.nationality == 'Chad'"> Chad </span></p>
              <p><span v-if="value.nationality == 'Chile'"> Chile </span></p>
              <p><span v-if="value.nationality == 'China'"> China </span></p>
              <p><span v-if="value.nationality == 'Cyprus'"> Chipre </span><span v-else-if="value.nationality == 'Chipre'">Chipre </span></p>
              <p><span v-if="value.nationality == 'Vatican City'"> Ciudad del Vaticano </span><span v-else-if="value.nationality == 'Ciudad del Vaticano'">Ciudad del Vaticano </span></p>
              <p><span v-if="value.nationality == 'Colombia'"> Colombia </span></p>
              <p><span v-if="value.nationality == 'Comoros'"> Comoras </span><span v-else-if="value.nationality == 'Comoras'">Comoras </span></p>
              <p><span v-if="value.nationality == 'North Korea'"> Corea del Norte </span><span v-else-if="value.nationality == 'Corea del Norte'">Corea del Norte </span></p>
              <p><span v-if="value.nationality == 'South Korea'"> Corea del Sur </span><span v-else-if="value.nationality == 'Corea del Sur'">Corea del Sur </span></p>
              <p><span v-if="value.nationality == 'Ivory Coast'"> Costa de Marfil </span><span v-else-if="value.nationality == 'Costa de Marfil'">Costa de Marfil </span></p>
              <p><span v-if="value.nationality == 'Costa Rica'"> Costa Rica </span></p>
              <p><span v-if="value.nationality == 'Croatia'"> Croacia </span><span v-else-if="value.nationality == 'Croacia'">Croacia </span></p>
              <p><span v-if="value.nationality == 'Cuba'"> Cuba </span></p>
              <p><span v-if="value.nationality == 'Denmark'"> Dinamarca </span><span v-else-if="value.nationality == 'Dinamarca'">Dinamarca </span></p>
              <p><span v-if="value.nationality == 'Dominica'"> Dominica </span></p>
              <p><span v-if="value.nationality == 'Ecuador'"> Ecuador </span></p>
              <p><span v-if="value.nationality == 'Egypt'"> Egipto </span><span v-else-if="value.nationality == 'Egipto'">Egipto </span></p>
              <p><span v-if="value.nationality == 'El Salvador'"> El Salvador </span></p>
              <p><span v-if="value.nationality == 'United Arab Emirates'"> Emiratos Árabes Unidos </span><span v-else-if="value.nationality == 'Emiratos Árabes Unidos'">Emiratos Árabes Unidos </span></p>
              <p><span v-if="value.nationality == 'Eritrea'"> Eritrea </span></p>
              <p><span v-if="value.nationality == 'England'"> Inglaterra </span><span v-else-if="value.nationality == 'Inglaterra'">Inglaterra </span></p>
              <p><span v-if="value.nationality == 'Slovakia'"> Eslovaquia </span><span v-else-if="value.nationality == 'Eslovaquia'">Eslovaquia </span></p>
              <p><span v-if="value.nationality == 'Slovenia'"> Eslovenia </span><span v-else-if="value.nationality == 'Eslovenia'">Eslovenia </span></p>
              <p><span v-if="value.nationality == 'Spain'"> España </span><span v-else-if="value.nationality == 'España'">España </span></p>
              <p><span v-if="value.nationality == 'U.S'"> Estados Unidos </span><span v-else-if="value.nationality == 'Estados Unidos'">Estados Unidos </span></p>
              <p><span v-if="value.nationality == 'Estonia'"> Estonia </span></p>
              <p><span v-if="value.nationality == 'Ethiopia'"> Etiopía </span><span v-else-if="value.nationality == 'Etiopía'">Etiopía </span></p>
              <p><span v-if="value.nationality == 'Filipinas'"> Filipinas </span></p>
              <p><span v-if="value.nationality == 'Finlandia'"> Finlandia </span></p>
              <p><span v-if="value.nationality == 'Fiyi'"> Fiyi </span></p>
              <p><span v-if="value.nationality == 'France'"> Francia </span></p>
              <p><span v-if="value.nationality == 'Gabon'"> Gabón </span><span v-else-if="value.nationality == 'Gabón'">Gabón </span></p>
              <p><span v-if="value.nationality == 'Gambia'"> Gambia </span></p>
              <p><span v-if="value.nationality == 'Georgia'"> Georgia </span></p>
              <p><span v-if="value.nationality == 'Gibraltar'"> Gibraltar </span></p>
              <p><span v-if="value.nationality == 'Ghana'"> Ghana </span></p>
              <p><span v-if="value.nationality == 'Granada'"> Granada </span></p>
              <p><span v-if="value.nationality == 'Grecia'"> Grecia </span></p>
              <p><span v-if="value.nationality == 'Groenlandia'"> Groenlandia </span></p>
              <p><span v-if="value.nationality == 'Guatemala'"> Guatemala </span></p>
              <p><span v-if="value.nationality == 'Guinea ecuatorial'"> Guinea ecuatorial </span></p>
              <p><span v-if="value.nationality == 'Guinea'"> Guinea </span></p>
              <p><span v-if="value.nationality == 'Guinea-Bisáu'"> Guinea-Bisáu </span></p>
              <p><span v-if="value.nationality == 'Guyana'"> Guyana </span></p>
              <p><span v-if="value.nationality == 'Haiti'"> Haití </span><span v-else-if="value.nationality == 'Haití'">Haití </span></p>
              <p><span v-if="value.nationality == 'Honduras'"> Honduras </span></p>
              <p><span v-if="value.nationality == 'Hungary'"> Hungría </span><span v-else-if="value.nationality == 'Hungría'">Hungría </span></p>
              <p><span v-if="value.nationality == 'India'"> India </span></p>
              <p><span v-if="value.nationality == 'Indonesia'"> Indonesia </span></p>
              <p><span v-if="value.nationality == 'Iraq'"> Irak </span><span v-else-if="value.nationality == 'Irak'">Irak </span></p>
              <p><span v-if="value.nationality == 'Iran'"> Irán </span><span v-else-if="value.nationality == 'Irán'">Irán </span></p>
              <p><span v-if="value.nationality == 'Ireland'"> Irlanda </span><span v-else-if="value.nationality == 'Irlanda'">Irlanda </span></p>
              <p><span v-if="value.nationality == 'Iceland'"> Islandia </span><span v-else-if="value.nationality == 'Islandia'">Islandia </span></p>
              <p><span v-if="value.nationality == 'Cook islands'"> Islas Cook </span><span v-else-if="value.nationality == 'Islas Cook'">Islas Cook </span></p>
              <p><span v-if="value.nationality == 'Marshall Islands'"> Islas Marshall </span><span v-else-if="value.nationality == 'Islas Marshall'">Islas Marshall </span></p>
              <p><span v-if="value.nationality == 'Solomon Islands'"> Islas Salomón </span><span v-else-if="value.nationality == 'Islas Salomón'">Islas Salomón </span></p>
              <p><span v-if="value.nationality == 'Israel'"> Israel </span></p>
              <p><span v-if="value.nationality == 'Italy'"> Italia </span><span v-else-if="value.nationality == 'Italia'">Italia </span></p>
              <p><span v-if="value.nationality == 'Jamaica'"> Jamaica </span></p>
              <p><span v-if="value.nationality == 'Japan'"> Japón </span><span v-else-if="value.nationality == 'Japón'">Japón </span></p>
              <p><span v-if="value.nationality == 'Jordan'"> Jordania </span><span v-else-if="value.nationality == 'Jordania'">Jordania </span></p>
              <p><span v-if="value.nationality == 'Kazakhstan'"> Kazajistán </span><span v-else-if="value.nationality == 'Kazajistán'">Kazajistán </span></p>
              <p><span v-if="value.nationality == 'Kenya'"> Kenia </span><span v-else-if="value.nationality == 'Kenia'">Kenia </span></p>
              <p><span v-if="value.nationality == 'Kiribati'"> Kiribati </span></p>
              <p><span v-if="value.nationality == 'Kuwait'"> Kuwait </span></p>
              <p><span v-if="value.nationality == 'Laos'"> Laos </span></p>
              <p><span v-if="value.nationality == 'Lesotho'"> Lesoto </span><span v-else-if="value.nationality == 'Lesoto'">Lesoto </span></p>
              <p><span v-if="value.nationality == 'Latvia'"> Letonia </span><span v-else-if="value.nationality == 'Letonia'">Letonia </span></p>
              <p><span v-if="value.nationality == 'Lebanon'"> Líbano </span><span v-else-if="value.nationality == 'Líbano'">Líbano </span></p>
              <p><span v-if="value.nationality == 'Liberia'"> Liberia </span></p>
              <p><span v-if="value.nationality == 'Liechtenstein'"> Liechtenstein </span></p>
              <p><span v-if="value.nationality == 'Lituania'"> Lituania </span></p>
              <p><span v-if="value.nationality == 'Luxemburgo'"> Luxemburgo </span></p>
              <p><span v-if="value.nationality == 'Madagascar'"> Madagascar </span></p>
              <p><span v-if="value.nationality == 'Malasia'"> Malasia </span></p>
              <p><span v-if="value.nationality == 'Malaui'"> Malaui </span></p>
              <p><span v-if="value.nationality == 'Maldivas'"> Maldivas </span></p>
              <p><span v-if="value.nationality == 'Mali'"> Malí </span><span v-else-if="value.nationality == 'Malí'">Malí </span></p>
              <p><span v-if="value.nationality == 'Malta'"> Malta </span></p>
              <p><span v-if="value.nationality == 'Marruecos'"> Marruecos </span></p>
              <p><span v-if="value.nationality == 'Martinica'"> Martinica </span></p>
              <p><span v-if="value.nationality == 'Mauricio'"> Mauricio </span></p>
              <p><span v-if="value.nationality == 'Mauritania'"> Mauritania </span></p>
              <p><span v-if="value.nationality == 'Mexico'"> México </span><span v-else-if="value.nationality == 'México'">México </span></p>
              <p><span v-if="value.nationality == 'Micronesia'"> Micronesia </span></p>
              <p><span v-if="value.nationality == 'Moldova'"> Moldavia </span><span v-else-if="value.nationality == 'Moldavia'">Moldavia </span></p>
              <p><span v-if="value.nationality == 'Monaco'"> Mónaco </span><span v-else-if="value.nationality == 'Mónaco'">Mónaco </span></p>
              <p><span v-if="value.nationality == 'Mongolia'"> Mongolia </span></p>
              <p><span v-if="value.nationality == 'Montenegro'"> Montenegro </span></p>
              <p><span v-if="value.nationality == 'Mozambique'"> Mozambique </span></p>
              <p><span v-if="value.nationality == 'Namibia'"> Namibia </span></p>
              <p><span v-if="value.nationality == 'Nauru'"> Nauru </span></p>
              <p><span v-if="value.nationality == 'Nepal'"> Nepal </span></p>
              <p><span v-if="value.nationality == 'Nicaragua'"> Nicaragua </span></p>
              <p><span v-if="value.nationality == 'Niger'"> Nigeria </span></p>
              <p><span v-if="value.nationality == 'Norway'"> Noruega </span><span v-else-if="value.nationality == 'Noruega'">Noruega </span></p>
              <p><span v-if="value.nationality == 'New Zealand'"> Nueva Zelanda </span><span v-else-if="value.nationality == 'Nueva Zelanda'">Nueva Zelanda </span></p>
              <p><span v-if="value.nationality == 'Oman'"> Omán </span><span v-else-if="value.nationality == 'Omán'">Omán </span></p>
              <p><span v-if="value.nationality == 'Netherlands'"> Países Bajos </span><span v-else-if="value.nationality == 'Países Bajos'">Países Bajos </span></p>
              <p><span v-if="value.nationality == 'Pakistan'"> Pakistán </span><span v-else-if="value.nationality == 'Pakistán'">Pakistán </span></p>
              <p><span v-if="value.nationality == 'Palau'"> Palaos </span><span v-else-if="value.nationality == 'Palaos'">Palaos </span></p>
              <p><span v-if="value.nationality == 'Palestine'"> Palestina </span><span v-else-if="value.nationality == 'Palestina'">Palestina </span></p>
              <p><span v-if="value.nationality == 'Panama'"> Panamá </span><span v-else-if="value.nationality == 'Panamá'">Panamá </span></p>
              <p><span v-if="value.nationality == 'Papua New Guinea'"> Papúa Nueva Guinea </span><span v-else-if="value.nationality == 'Papúa Nueva Guinea'">Papúa Nueva Guinea </span></p>
              <p><span v-if="value.nationality == 'Paraguay'"> Paraguay </span></p>
              <p><span v-if="value.nationality == 'Peru'"> Peru </span></p>
              <p><span v-if="value.nationality == 'Poland'"> Polonia </span><span v-else-if="value.nationality == 'Polonia'">Polonia </span></p>
              <p><span v-if="value.nationality == 'Portugal'"> Portugal </span></p>
              <p><span v-if="value.nationality == 'Puerto Rico'"> Puerto Rico </span></p>
              <p><span v-if="value.nationality == 'UK'"> Reino Unido </span><span v-else-if="value.nationality == 'Reino Unido'">Reino Unido </span></p>
              <p><span v-if="value.nationality == 'Central African Republic'"> República Centroafricana </span><span v-else-if="value.nationality == 'República Centroafricana'">República Centroafricana </span></p>
              <p><span v-if="value.nationality == 'Czech Republic'"> República Checa </span><span v-else-if="value.nationality == 'República Checa'">República Checa </span></p>
              <p><span v-if="value.nationality == 'Republic of Macedonia'"> República de Macedonia </span><span v-else-if="value.nationality == 'República de Macedonia'">República de Macedonia </span></p>
              <p><span v-if="value.nationality == 'Republic of Congo'"> República del Congo </span><span v-else-if="value.nationality == 'República del Congo'">República del Congo </span></p>
              <p><span v-if="value.nationality == 'Democratic Republic of Congo'"> República Democrática del Congo </span><span v-else-if="value.nationality == 'República Democrática del Congo'">República Democrática del Congo </span></p>
              <p><span v-if="value.nationality == 'Dominican Republic'"> República Dominicana </span><span v-else-if="value.nationality == 'República Dominicana'">República Dominicana </span></p>
              <p><span v-if="value.nationality == 'Sudafrican republic'"> República Sudafricana </span><span v-else-if="value.nationality == 'República Sudafricana'">República Sudafricana </span></p>
              <p><span v-if="value.nationality == 'Rwanda'"> Ruanda </span><span v-else-if="value.nationality == 'Ruanda'">Ruanda </span></p>
              <p><span v-if="value.nationality == 'Romania'"> Rumanía </span><span v-else-if="value.nationality == 'Rumanía'">Rumanía </span></p>
              <p><span v-if="value.nationality == 'Russia'"> Rusia </span><span v-else-if="value.nationality == 'Rusia'">Rusia </span></p>
              <p><span v-if="value.nationality == 'Samoa'"> Samoa </span></p>
              <p><span v-if="value.nationality == 'Saint Kitts and Nevis'"> San Cristóbal y Nieves </span><span v-else-if="value.nationality == 'San Cristóbal y Nieves'">San Cristóbal y Nieves </span></p>
              <p><span v-if="value.nationality == 'San Marino'"> San Marino </span></p>
              <p><span v-if="value.nationality == 'St. Vincent and the Grenadines'"> San Vicente y las Granadinas </span><span v-else-if="value.nationality == 'San Vicente y las Granadinas'">San Vicente y las Granadinas </span></p>
              <p><span v-if="value.nationality == 'St. Lucia'"> Santa Lucía </span><span v-else-if="value.nationality == 'Santa Lucía'">Santa Lucía </span></p>
              <p><span v-if="value.nationality == 'Sao Tome and Principe'"> Santo Tomé y Príncipe </span><span v-else-if="value.nationality == 'Santo Tomé y Príncipe'">Santo Tomé y Príncipe </span></p>
              <p><span v-if="value.nationality == 'Senegal'"> Senegal </span></p>
              <p><span v-if="value.nationality == 'Serbia'"> Serbia </span></p>
              <p><span v-if="value.nationality == 'Seychelles'"> Seychelles </span></p>
              <p><span v-if="value.nationality == 'Sierra Leone'"> Sierra Leona </span><span v-else-if="value.nationality == 'Sierra Leona'">Sierra Leona </span></p>
              <p><span v-if="value.nationality == 'Singapore'"> Singapur </span><span v-else-if="value.nationality == 'Singapur'">Singapur </span></p>
              <p><span v-if="value.nationality == 'Syria'"> Siria </span><span v-else-if="value.nationality == 'Siria'">Siria </span></p>
              <p><span v-if="value.nationality == 'Somalia'"> Somalia </span></p>
              <p><span v-if="value.nationality == 'Sri lanka'"> SriLanka </span><span v-else-if="value.nationality == 'SriLanka'">SriLanka </span></p>
              <p><span v-if="value.nationality == 'Swaziland'"> Suazilandia </span><span v-else-if="value.nationality == 'Suazilandia'">Suazilandia </span></p>
              <p><span v-if="value.nationality == 'South Sudan'"> Sudán del Sur </span><span v-else-if="value.nationality == 'Sudán del Sur'">Sudán del Sur </span></p>
              <p><span v-if="value.nationality == 'Sudan'"> Sudán </span><span v-else-if="value.nationality == 'Sudán'">Sudán </span></p>
              <p><span v-if="value.nationality == 'Sweden'"> Suecia </span><span v-else-if="value.nationality == 'Suecia'">Suecia </span></p>
              <p><span v-if="value.nationality == 'Switzerland'"> Suiza </span><span v-else-if="value.nationality == 'Suiza'">Suiza </span></p>
              <p><span v-if="value.nationality == 'Surinam'"> Surinam </span></p>
              <p><span v-if="value.nationality == 'Thailand'"> Tailandia </span><span v-else-if="value.nationality == 'Tailandia'">Tailandia </span></p>
              <p><span v-if="value.nationality == 'Tanzania'"> Tanzania </span></p>
              <p><span v-if="value.nationality == 'Tajikistan'"> Tayikistán </span><span v-else-if="value.nationality == 'Tayikistán'">Tayikistán </span></p>
              <p><span v-if="value.nationality == 'East Timor'"> Timor Oriental </span><span v-else-if="value.nationality == 'Timor Oriental'">Timor Oriental </span></p>
              <p><span v-if="value.nationality == 'Togo'"> Togo </span></p>
              <p><span v-if="value.nationality == 'Tonga'"> Tonga </span></p>
              <p><span v-if="value.nationality == 'Trinidad and Tobago'"> Trinidad y Tobago </span><span v-else-if="value.nationality == 'Trinidad y Tobago'">Trinidad y Tobago </span></p>
              <p><span v-if="value.nationality == 'Tunisia'"> Túnez </span><span v-else-if="value.nationality == 'Túnez'">Túnez </span></p>
              <p><span v-if="value.nationality == 'Turkmenistan'"> Turkmenistán </span><span v-else-if="value.nationality == 'Turkmenistán'">Turkmenistán </span></p>
              <p><span v-if="value.nationality == 'Turkey'"> Turquía </span><span v-else-if="value.nationality == 'Turquía'">Turquía </span></p>
              <p><span v-if="value.nationality == 'Tuvalu'"> Tuvalu </span></p>
              <p><span v-if="value.nationality == 'Ukraine'"> Ucrania </span><span v-else-if="value.nationality == 'Ucrania'">Ucrania </span></p>
              <p><span v-if="value.nationality == 'Uganda'"> Uganda </span></p>
              <p><span v-if="value.nationality == 'Uruguay'"> Uruguay </span></p>
              <p><span v-if="value.nationality == 'Uzbekistan'"> Uzbekistán </span><span v-else-if="value.nationality == 'Uzbekistán'">Uzbekistán </span></p>
              <p><span v-if="value.nationality == 'Vanuatu'"> Vanuatu </span></p>
              <p><span v-if="value.nationality == 'Venezuela'"> Venezuela </span></p>
              <p><span v-if="value.nationality == 'Vietnam'"> Vietnam </span></p>
              <p><span v-if="value.nationality == 'Yemen'"> Yemen </span></p>
              <p><span v-if="value.nationality == 'Djibouti'"> Yibuti </span><span v-else-if="value.nationality == 'Yibuti'">Yibuti </span></p>
              <p><span v-if="value.nationality == 'Zambia'"> Zambia </span></p>
              <p><span v-if="value.nationality == 'Zimbabwe'"> Zimbabue </span><span v-else-if="value.nationality == 'Zimbabue'">Zimbabue </span></p>
            </td>
            <td v-else v-on:click="handleRow(index)" class="show-desktop-d" data-toggle="collapse" :data-target="'#detail' + index">
              <p><span v-if="value.nationality == 'Afganistán'"> Afganistan </span><span v-else-if="value.nationality == 'Afganistan'">Afganistan </span></p>
              <p><span v-if="value.nationality == 'Albania'"> Albania </span></p>
              <p><span v-if="value.nationality == 'Alemania'"> Germany </span><span v-else-if="value.nationality == 'Germany'">Germany </span></p>
              <p><span v-if="value.nationality == 'Angola'"> Angola </span></p>
              <p><span v-if="value.nationality == 'Antigua y Barbuda'"> Antigua y Barbuda </span></p>
              <p><span v-if="value.nationality == 'Arabia Saudita'"> Saudi Arabia </span><span v-else-if="value.nationality == 'Saudi Arabia'">Saudi Arabia </span></p>
              <p><span v-if="value.nationality == 'Argelia'"> Algeria </span><span v-else-if="value.nationality == 'Algeria'">Algeria </span></p>
              <p><span v-if="value.nationality == 'Argentina'"> Argentina </span></p>
              <p><span v-if="value.nationality == 'Armenia'"> Armenia </span></p>
              <p><span v-if="value.nationality == 'Aruba'"> Aruba </span></p>
              <p><span v-if="value.nationality == 'Australia'"> Australia </span></p>
              <p><span v-if="value.nationality == 'Austria'"> Austria </span></p>
              <p><span v-if="value.nationality == 'Azerbaiyán'"> Azerbaijan </span><span v-else-if="value.nationality == 'Azerbaijan'">Azerbaijan </span></p>
              <p><span v-if="value.nationality == 'Bahamas'"> Bahamas </span></p>
              <p><span v-if="value.nationality == 'Bangladés'"> Bangladesh </span><span v-else-if="value.nationality == 'Bangladesh'">Bangladesh </span></p>
              <p><span v-if="value.nationality == 'Barbados'"> Barbados </span></p>
              <p><span v-if="value.nationality == 'Baréin'"> Bahrain </span><span v-else-if="value.nationality == 'Bahrain'">Bahrain </span></p>
              <p><span v-if="value.nationality == 'Belgium'"> Bélgica </span><span v-else-if="value.nationality == 'Bélgica'">Bélgica </span></p>
              <p><span v-if="value.nationality == 'Belice'"> Belize </span><span v-else-if="value.nationality == 'Belize'">Belize </span></p>
              <p><span v-if="value.nationality == 'Benín'"> Benin </span><span v-else-if="value.nationality == 'Benin'">Benin </span></p>
              <p><span v-if="value.nationality == 'Bielorrusia'"> Belarus </span><span v-else-if="value.nationality == 'Belarus'">Belarus </span></p>
              <p><span v-if="value.nationality == 'Birmania'"> Burma </span><span v-else-if="value.nationality == 'Burma'">Burma </span></p>
              <p><span v-if="value.nationality == 'Bolivia'"> Bolivia </span></p>
              <p><span v-if="value.nationality == 'Bosnia and Herzegovina'"> Bosnia and Herzegovina </span></p>
              <p><span v-if="value.nationality == 'Botsuana'"> Botswana </span><span v-else-if="value.nationality == 'Botswana'">Botswana </span></p>
              <p><span v-if="value.nationality == 'Brasil'"> Brazil </span><span v-else-if="value.nationality == 'Brazil'">Brazil </span></p>
              <p><span v-if="value.nationality == 'Brunei'"> Brunei </span></p>
              <p><span v-if="value.nationality == 'Bulgaria'"> Bulgaria </span></p>
              <p><span v-if="value.nationality == 'Burkina Faso'"> Burkina Faso </span></p>
              <p><span v-if="value.nationality == 'Burundi'"> Burundi </span></p>
              <p><span v-if="value.nationality == 'Bután'"> Bhutan </span><span v-else-if="value.nationality == 'Bhutan'">Bhutan </span></p>
              <p><span v-if="value.nationality == 'Cabo Verde'">Cape Verde </span><span v-else-if="value.nationality == 'Cape Verde'">Cape Verde </span></p>
              <p><span v-if="value.nationality == 'Camboya'"> Cambodia </span><span v-else-if="value.nationality == 'Cambodia'">Cambodia </span></p>
              <p><span v-if="value.nationality == 'Camerún'"> Cameroon </span><span v-else-if="value.nationality == 'Cameroon'">Cameroon </span></p>
              <p><span v-if="value.nationality == 'Canadá'"> Canada </span><span v-else-if="value.nationality == 'Canada'">Canada </span></p>
              <p><span v-if="value.nationality == 'Catar'"> Qatar </span><span v-else-if="value.nationality == 'Qatar'">Qatar </span></p>
              <p><span v-if="value.nationality == 'Chad'"> Chad </span></p>
              <p><span v-if="value.nationality == 'Chile'"> Chile </span></p>
              <p><span v-if="value.nationality == 'China'"> China </span></p>
              <p><span v-if="value.nationality == 'Chipre'"> Cyprus </span><span v-else-if="value.nationality == 'Cyprus'">Cyprus </span></p>
              <p><span v-if="value.nationality == 'Ciudad del Vaticano'">Vatican City </span><span v-else-if="value.nationality == 'Vatican City'">Vatican City </span></p>
              <p><span v-if="value.nationality == 'Colombia'"> Colombia </span></p>
              <p><span v-if="value.nationality == 'Comoros'"> Comoras </span><span v-else-if="value.nationality == 'Comoras'">Comoras </span></p>
              <p><span v-if="value.nationality == 'Corea del Norte '"> North Korea </span><span v-else-if="value.nationality == 'North Korea'">North Korea </span></p>
              <p><span v-if="value.nationality == 'Corea del Sur '"> South Korea </span><span v-else-if="value.nationality == 'South Korea'">South Korea </span></p>
              <p><span v-if="value.nationality == 'Costa de Marfil'"> Ivory Coast </span><span v-else-if="value.nationality == 'Ivory Coast'">Ivory Coast </span></p>
              <p><span v-if="value.nationality == 'Costa Rica'"> Costa Rica </span></p>
              <p><span v-if="value.nationality == 'Croacia'"> Croatia </span><span v-else-if="value.nationality == 'Croatia'">Croatia </span></p>
              <p><span v-if="value.nationality == 'Cuba'"> Cuba </span></p>
              <p><span v-if="value.nationality == 'Dinamarca'"> Denmark  </span><span v-else-if="value.nationality == 'Denmark'">Denmark </span></p>
              <p><span v-if="value.nationality == 'Dominica'"> Dominica </span></p>
              <p><span v-if="value.nationality == 'Ecuador'"> Ecuador </span></p>
              <p><span v-if="value.nationality == 'Egipto'"> Egypt  </span><span v-else-if="value.nationality == 'Egypt'">Egypt </span></p>
              <p><span v-if="value.nationality == 'El Salvador'"> El Salvador </span></p>
              <p><span v-if="value.nationality == 'Emiratos Árabes Unidos'"> United Arab Emirates </span><span v-else-if="value.nationality == 'United Arab Emirates'">United Arab Emirates </span></p>
              <p><span v-if="value.nationality == 'Eritrea'"> Eritrea </span></p>
              <p><span v-if="value.nationality == 'Inglaterra'"> England </span><span v-else-if="value.nationality == 'England'">England </span></p>
              <p><span v-if="value.nationality == 'Eslovaquia'"> Slovakia  </span><span v-else-if="value.nationality == 'Slovakia'">Slovakia </span></p>
              <p><span v-if="value.nationality == 'Eslovenia'"> Slovenia </span><span v-else-if="value.nationality == 'Slovenia'">Slovenia </span></p>
              <p><span v-if="value.nationality == 'España'"> Spain </span><span v-else-if="value.nationality == 'Spain'">Spain </span></p>
              <p><span v-if="value.nationality == 'Estados Unidos'"> U.S </span><span v-else-if="value.nationality == 'U.S'">U.S </span></p>
              <p><span v-if="value.nationality == 'Estonia'"> Estonia </span></p>
              <p><span v-if="value.nationality == 'Etiopía'">Ethiopia  </span><span v-else-if="value.nationality == 'Ethiopia'">Ethiopia </span></p>
              <p><span v-if="value.nationality == 'Filipinas'"> Filipinas </span></p>
              <p><span v-if="value.nationality == 'Finlandia'"> Finlandia </span></p>
              <p><span v-if="value.nationality == 'Fiyi'"> Fiyi </span></p>
              <p><span v-if="value.nationality == 'France'"> Francia </span>
              <p><span v-if="value.nationality == 'Gabón'"> Gabon </span><span v-else-if="value.nationality == 'Gabon'">Gabon </span></p>
              <p><span v-if="value.nationality == 'Gambia'"> Gambia </span></p>
              <p><span v-if="value.nationality == 'Georgia'"> Georgia </span></p>
              <p><span v-if="value.nationality == 'Gibraltar'"> Gibraltar </span></p>
              <p><span v-if="value.nationality == 'Ghana'"> Ghana </span></p>
              <p><span v-if="value.nationality == 'Granada'"> Granada </span></p>
              <p><span v-if="value.nationality == 'Grecia'"> Grecia </span></p>
              <p><span v-if="value.nationality == 'Groenlandia'"> Groenlandia </span></p>
              <p><span v-if="value.nationality == 'Guatemala'"> Guatemala </span></p>
              <p><span v-if="value.nationality == 'Guinea ecuatorial'"> Guinea ecuatorial </span></p>
              <p><span v-if="value.nationality == 'Guinea'"> Guinea </span></p>
              <p><span v-if="value.nationality == 'Guinea-Bisáu'"> Guinea-Bisáu </span></p>
              <p><span v-if="value.nationality == 'Guyana'"> Guyana </span></p>
              <p><span v-if="value.nationality == 'Haiti'"> Haiti </span><span v-else-if="value.nationality == 'Haití'">Haití </span></p>
              <p><span v-if="value.nationality == 'Honduras'"> Honduras </span></p>
              <p><span v-if="value.nationality == 'Hungría'"> Hungría </span><span v-else-if="value.nationality == 'Hungary'">Hungary </span></p>
              <p><span v-if="value.nationality == 'India'"> India </span></p>
              <p><span v-if="value.nationality == 'Indonesia'"> Indonesia </span></p>
              <p><span v-if="value.nationality == 'Irak'"> Iraq </span><span v-else-if="value.nationality == 'Iraq'">Iraq </span></p>
              <p><span v-if="value.nationality == 'Irán'"> Iran </span><span v-else-if="value.nationality == 'Iran'">Iran </span></p>
              <p><span v-if="value.nationality == 'Irlanda'"> Ireland </span><span v-else-if="value.nationality == 'Ireland'">Ireland </span></p>
              <p><span v-if="value.nationality == 'Islandia'"> Iceland </span><span v-else-if="value.nationality == 'Iceland'">Iceland </span></p>
              <p><span v-if="value.nationality == 'Islas Cook'"> Islas Cook </span><span v-else-if="value.nationality == 'Cook islands'">Cook islands</span></p>
              <p><span v-if="value.nationality == 'Islas Marshall'"> Marshall Islands </span><span v-else-if="value.nationality == 'Marshall Islands'">Marshall Islands </span></p>
              <p><span v-if="value.nationality == 'Islas Salomón'"> Solomon Islands </span><span v-else-if="value.nationality == 'Solomon Islands'">Solomon Islands </span></p>
              <p><span v-if="value.nationality == 'Israel'"> Israel </span></p>
              <p><span v-if="value.nationality == 'Italia'"> Italy  </span><span v-else-if="value.nationality == 'Italy'">Italy </span></p>
              <p><span v-if="value.nationality == 'Jamaica'"> Jamaica </span></p>
              <p><span v-if="value.nationality == 'Japón'"> Japan </span><span v-else-if="value.nationality == 'Japan'">Japan </span></p>
              <p><span v-if="value.nationality == 'Jordania'"> Jordan </span><span v-else-if="value.nationality == 'Jordan'">Jordan </span></p>
              <p><span v-if="value.nationality == 'Kazajistán'"> Kazakhstan </span><span v-else-if="value.nationality == 'Kazakhstan'">Kazakhstan </span></p>
              <p><span v-if="value.nationality == 'Kenia'"> Kenya </span><span v-else-if="value.nationality == 'Kenya'">Kenya </span></p>
              <p><span v-if="value.nationality == 'Kiribati'"> Kiribati </span></p>
              <p><span v-if="value.nationality == 'Kuwait'"> Kuwait </span></p>
              <p><span v-if="value.nationality == 'Laos'"> Laos </span></p>
              <p><span v-if="value.nationality == 'Lesoto'">Lesotho </span><span v-else-if="value.nationality == 'Lesotho'">Lesotho </span></p>
              <p><span v-if="value.nationality == 'Letonia'"> Latvia </span><span v-else-if="value.nationality == 'Latvia'">Latvia </span></p>
              <p><span v-if="value.nationality == 'Líbano'"> Lebanon  </span><span v-else-if="value.nationality == 'Lebanon'">Lebanon </span></p>
              <p><span v-if="value.nationality == 'Liberia'"> Liberia </span></p>
              <p><span v-if="value.nationality == 'Liechtenstein'"> Liechtenstein </span></p>
              <p><span v-if="value.nationality == 'Lituania'"> Lituania </span></p>
              <p><span v-if="value.nationality == 'Luxemburgo'"> Luxemburgo </span></p>
              <p><span v-if="value.nationality == 'Madagascar'"> Madagascar </span></p>
              <p><span v-if="value.nationality == 'Malasia'"> Malasia </span></p>
              <p><span v-if="value.nationality == 'Malaui'"> Malaui </span></p>
              <p><span v-if="value.nationality == 'Maldivas'"> Maldivas </span></p>
              <p><span v-if="value.nationality == 'Malí'"> Mali </span><span v-else-if="value.nationality == 'Mali'">Mali </span></p>
              <p><span v-if="value.nationality == 'Malta'"> Malta </span></p>
              <p><span v-if="value.nationality == 'Marruecos'"> Marruecos </span></p>
              <p><span v-if="value.nationality == 'Martinica'"> Martinica </span></p>
              <p><span v-if="value.nationality == 'Mauricio'"> Mauricio </span></p>
              <p><span v-if="value.nationality == 'Mauritania'"> Mauritania </span></p>
              <p><span v-if="value.nationality == 'México '"> Mexico</span><span v-else-if="value.nationality == 'Mexico'">Mexico </span></p>
              <p><span v-if="value.nationality == 'Micronesia'"> Micronesia </span></p>
              <p><span v-if="value.nationality == 'Moldavia'"> Moldova  </span><span v-else-if="value.nationality == 'Moldova'">Moldova </span></p>
              <p><span v-if="value.nationality == 'Monaco'"> Mónaco </span><span v-else-if="value.nationality == 'Mónaco'">Mónaco </span></p>
              <p><span v-if="value.nationality == 'Mongolia'"> Mongolia </span></p>
              <p><span v-if="value.nationality == 'Montenegro'"> Montenegro </span></p>
              <p><span v-if="value.nationality == 'Mozambique'"> Mozambique </span></p>
              <p><span v-if="value.nationality == 'Namibia'"> Namibia </span></p>
              <p><span v-if="value.nationality == 'Nauru'"> Nauru </span></p>
              <p><span v-if="value.nationality == 'Nepal'"> Nepal </span></p>
              <p><span v-if="value.nationality == 'Nicaragua'"> Nicaragua </span></p>
              <p><span v-if="value.nationality == 'Niger'"> Nigeria </span></p>
              <p><span v-if="value.nationality == 'Noruega'"> Norway </span><span v-else-if="value.nationality == 'Norway'">Norway </span></p>
              <p><span v-if="value.nationality == 'Nueva Zelanda'"> New Zealand </span><span v-else-if="value.nationality == 'New Zealand'">New Zealand </span></p>
              <p><span v-if="value.nationality == 'Omán'"> Oman  </span><span v-else-if="value.nationality == 'Oman'">Oman </span></p>
              <p><span v-if="value.nationality == 'Países Bajos'">Netherlands </span><span v-else-if="value.nationality == 'Netherlands'">Netherlands </span></p>
              <p><span v-if="value.nationality == 'Pakistán'"> Pakistan  </span><span v-else-if="value.nationality == 'Pakistan'">Pakistan </span></p>
              <p><span v-if="value.nationality == 'Palaos'"> Palau  </span><span v-else-if="value.nationality == 'Palau'">Palau </span></p>
              <p><span v-if="value.nationality == 'Palestina'"> Palestine  </span><span v-else-if="value.nationality == 'Palestine'">Palestine </span></p>
              <p><span v-if="value.nationality == 'Panamá'"> Panama  </span><span v-else-if="value.nationality == 'Panama'">Panama </span></p>
              <p><span v-if="value.nationality == 'Papúa Nueva Guinea'">Papua New Guinea </span><span v-else-if="value.nationality == 'Papua New Guinea'">Papua New Guinea </span></p>
              <p><span v-if="value.nationality == 'Paraguay'"> Paraguay </span></p>
              <p><span v-if="value.nationality == 'Peru'"> Peru </span></p>
              <p><span v-if="value.nationality == 'Polonia'"> Poland </span><span v-else-if="value.nationality == 'Poland'">Poland </span></p>
              <p><span v-if="value.nationality == 'Portugal'"> Portugal </span></p>
              <p><span v-if="value.nationality == 'Puerto Rico'"> Puerto Rico </span></p>
              <p><span v-if="value.nationality == 'Reino Unido'">UK </span><span v-else-if="value.nationality == 'UK'">UK </span></p>
              <p><span v-if="value.nationality == 'República Centroafricana '"> Central African Republic </span><span v-else-if="value.nationality == 'Central African Republic'">Central African Republic </span></p>
              <p><span v-if="value.nationality == 'República Checa'">Czech Republic  </span><span v-else-if="value.nationality == 'Czech Republic'">Czech Republic </span></p>
              <p><span v-if="value.nationality == 'República de Macedonia'"> Republic of Macedonia </span><span v-else-if="value.nationality == 'Republic of Macedonia'">Republic of Macedonia</span></p>
              <p><span v-if="value.nationality == 'República del Congo'"> Republic of Congo </span><span v-else-if="value.nationality == 'Republic of Congo'">Republic of Congo </span></p>
              <p><span v-if="value.nationality == 'República Democrática del Congoo'"> Democratic Republic of Congo </span><span v-else-if="value.nationality == 'Democratic Republic of Congo'">Democratic Republic of Congo </span></p>
              <p><span v-if="value.nationality == 'República Dominicana'"> Dominican Republic </span><span v-else-if="value.nationality == 'Dominican Republic'">Dominican Republic </span></p>
              <p><span v-if="value.nationality == 'República Sudafricana'">Sudafrican republic </span><span v-else-if="value.nationality == 'Sudafrican republic'">Sudafrican republic </span></p>
              <p><span v-if="value.nationality == 'Ruanda'"> Rwanda </span><span v-else-if="value.nationality == 'Rwanda'">Rwanda </span></p>
              <p><span v-if="value.nationality == 'Rumanía'"> Romania </span><span v-else-if="value.nationality == 'Romania'">Romania </span></p>
              <p><span v-if="value.nationality == 'Rusia'"> Russia  </span><span v-else-if="value.nationality == 'Russia'">Russia </span></p>
              <p><span v-if="value.nationality == 'Samoa'"> Samoa </span></p>
              <p><span v-if="value.nationality == 'San Cristóbal y Nieves'"> Saint Kitts and Nevis  </span><span v-else-if="value.nationality == 'Saint Kitts and Nevis '">Saint Kitts and Nevis  </span></p>
              <p><span v-if="value.nationality == 'San Marino'"> San Marino </span></p>
              <p><span v-if="value.nationality == 'San Vicente y las Granadinas'">St. Vincent and the Grenadines </span><span v-else-if="value.nationality == 'St. Vincent and the Grenadines'">St. Vincent and the Grenadines  </span></p>
              <p><span v-if="value.nationality == 'Santa Lucía'"> St. Lucia  </span><span v-else-if="value.nationality == 'St. Lucia'">St. Lucia </span></p>
              <p><span v-if="value.nationality == 'Santo Tomé y Príncipe'"> Santo Tome y Príncipe </span><span v-else-if="value.nationality == 'Sao Tome and Principe'">Sao Tome and Principe </span></p>
              <p><span v-if="value.nationality == 'Senegal'"> Senegal </span></p>
              <p><span v-if="value.nationality == 'Serbia'"> Serbia </span></p>
              <p><span v-if="value.nationality == 'Seychelles'"> Seychelles </span></p>
              <p><span v-if="value.nationality == 'Sierra Leona'">Sierra Leone </span><span v-else-if="value.nationality == 'Sierra Leone'">Sierra Leone </span></p>
              <p><span v-if="value.nationality == 'Singapur'"> Singapore </span><span v-else-if="value.nationality == 'Singapore'">Singapore </span></p>
              <p><span v-if="value.nationality == 'Siria'"> Syria </span><span v-else-if="value.nationality == 'Syria'">Syria </span></p>
              <p><span v-if="value.nationality == 'Somalia'"> Somalia </span></p>
              <p><span v-if="value.nationality == 'SriLanka'"> SriLanka </span><span v-else-if="value.nationality == 'Sri lanka'">Sri lanka </span></p>
              <p><span v-if="value.nationality == 'Suazilandia'"> Swaziland  </span><span v-else-if="value.nationality == 'Swaziland'">Swaziland </span></p>
              <p><span v-if="value.nationality == 'Sudán del Sur'"> South Sudan </span><span v-else-if="value.nationality == 'South Sudan'">South Sudan </span></p>
              <p><span v-if="value.nationality == 'Sudán'"> Sudan </span><span v-else-if="value.nationality == 'Sudan'">Sudan </span></p>
              <p><span v-if="value.nationality == 'Suecia'"> Sweden </span><span v-else-if="value.nationality == 'Sweden'">Sweden </span></p>
              <p><span v-if="value.nationality == 'Suiza'"> Switzerland </span><span v-else-if="value.nationality == 'Switzerland'">Switzerland </span></p>
              <p><span v-if="value.nationality == 'Surinam'"> Surinam </span></p>
              <p><span v-if="value.nationality == 'Tailandia'"> Thailand </span><span v-else-if="value.nationality == 'Thailand'">Thailand </span></p>
              <p><span v-if="value.nationality == 'Tanzania'"> Tanzania </span></p>
              <p><span v-if="value.nationality == 'Tayikistán'">Tajikistan </span><span v-else-if="value.nationality == 'Tajikistan'">Tajikistan </span></p>
              <p><span v-if="value.nationality == 'Timor Oriental'"> East Timor </span><span v-else-if="value.nationality == 'East Timor'">East Timor </span></p>
              <p><span v-if="value.nationality == 'Togo'"> Togo </span></p>
              <p><span v-if="value.nationality == 'Tonga'"> Tonga </span></p>
              <p><span v-if="value.nationality == 'Trinidad y Tobago'"> Trinidad and Tobago  </span><span v-else-if="value.nationality == 'Trinidad and Tobago'">Trinidad and Tobago </span></p>
              <p><span v-if="value.nationality == 'Túnez'"> Tunisia  </span><span v-else-if="value.nationality == 'Tunisia'">Tunisia </span></p>
              <p><span v-if="value.nationality == 'Turkmenistán'"> Turkmenistan </span><span v-else-if="value.nationality == 'Turkmenistan'">Turkmenistan </span></p>
              <p><span v-if="value.nationality == 'Turquía'"> Turkey </span><span v-else-if="value.nationality == 'Turkey'">Turkey </span></p>
              <p><span v-if="value.nationality == 'Tuvalu'"> Tuvalu </span></p>
              <p><span v-if="value.nationality == 'Ucrania'"> Ukraine </span><span v-else-if="value.nationality == 'Ukraine'">Ukraine </span></p>
              <p><span v-if="value.nationality == 'Uganda'"> Uganda </span></p>
              <p><span v-if="value.nationality == 'Uruguay'"> Uruguay </span></p>
              <p><span v-if="value.nationality == 'Uzbekistán'"> Uzbekistan </span><span v-else-if="value.nationality == 'Uzbekistan'">Uzbekistan </span></p>
              <p><span v-if="value.nationality == 'Vanuatu'"> Vanuatu </span></p>
              <p><span v-if="value.nationality == 'Venezuela'"> Venezuela </span></p>
              <p><span v-if="value.nationality == 'Vietnam'"> Vietnam </span></p>
              <p><span v-if="value.nationality == 'Yemen'"> Yemen </span></p>
              <p><span v-if="value.nationality == 'Yibuti'"> Djibouti </span><span v-else-if="value.nationality == 'Djibouti'">Djibouti </span></p>
              <p><span v-if="value.nationality == 'Zambia'"> Zambia </span></p>
              <p><span v-if="value.nationality == 'Zimbabue'">Zimbabwe </span><span v-else-if="value.nationality == 'Zimbabwe'">Zimbabwe </span></p>
            </td>
            <td v-if="$t('flag.flag') == 'es'" v-on:click="handleRow(index)" class="show-desktop-d" data-toggle="collapse" :data-target="'#detail' + index">
              <p><span v-if="value.passport == 'Afghan'"> Afgana </span><span v-else-if="value.passport == 'Afgana'">Afgana </span></p>
              <p><span v-if="value.passport == 'Albanian'"> Albanesa </span><span v-else-if="value.passport == 'Albanesa'">Albanesa </span></p>
              <p><span v-if="value.passport == 'German'"> Alemana </span><span v-else-if="value.passport == 'Alemana'">Alemana </span></p>
              <p><span v-if="value.passport == 'Angolan'"> Angoleaña </span><span v-else-if="value.passport == 'Angoleaña'">Angoleaña </span></p>
              <p><span v-if="value.passport == 'Antiguana'"> Antiguana </span></p>
              <p><span v-if="value.passport == 'Saudi'"> Saudí </span><span v-else-if="value.passport == 'Saudí'">Saudí </span></p>
              <p><span v-if="value.passport == 'Algerian'"> Argelina </span><span v-else-if="value.passport == 'Argelina'">Argelina </span></p>
              <p><span v-if="value.passport == 'Argentine'"> Argentina </span><span v-else-if="value.passport == 'Argentina'">Argentina </span></p>
              <p><span v-if="value.passport == 'Armenia'"> Armenia </span></p>
              <p><span v-if="value.passport == 'Aruban'"> Arubeña </span><span v-else-if="value.passport == 'Arubeña'">Arubeña </span></p>
              <p><span v-if="value.passport == 'Australia'"> Australia </span></p>
              <p><span v-if="value.passport == 'Austrain'"> Austriaca </span><span v-else-if="value.passport == 'Austriaca'">Austriaca </span></p>
              <p><span v-if="value.passport == 'Azerbaiyana'"> Azerbaiyana </span></p>
              <p><span v-if="value.passport == 'Bahaman'"> Bahameña </span><span v-else-if="value.passport == 'Bahameña'">Bahameña </span></p>
              <p><span v-if="value.passport == 'Bangkladesyes'"> Bangladesí </span><span v-else-if="value.passport == 'Bangladesí'">Bangladesí </span></p>
              <p><span v-if="value.passport == 'Barbadense'"> Barbadense </span></p>
              <p><span v-if="value.passport == 'Bareiní'"> Bareiní </span></p>
              <p><span v-if="value.passport == 'Belgian'"> Belga </span><span v-else-if="value.passport == 'Belga'">Belga </span></p>
              <p><span v-if="value.passport == 'Belize'"> Beliceña </span><span v-else-if="value.passport == 'Beliceña'">Beliceña </span></p>
              <p><span v-if="value.passport == 'Beninese'"> Beninesa </span><span v-else-if="value.passport == 'Beninesa'">Beninesa </span></p>
              <p><span v-if="value.passport == 'Belarus'"> Bielorrusa </span><span v-else-if="value.passport == 'Bielorrusa'">Bielorrusa </span></p>
              <p><span v-if="value.passport == 'Burma'"> Birmana </span><span v-else-if="value.passport == 'Birmana'">Birmana </span></p>
              <p><span v-if="value.passport == 'Boliviana'"> Boliviana </span></p>
              <p><span v-if="value.passport == 'Bosnia'">Bosnia </span></p>
              <p><span v-if="value.passport == 'Botswana'"> Botswana </span></p>
              <p><span v-if="value.passport == 'Brazilian'"> Brasileña </span><span v-else-if="value.passport == 'Brasileña'">Brasileña </span></p>
              <p><span v-if="value.passport == 'Bruneana'"> Bruneana </span></p>
              <p><span v-if="value.passport == 'Bulgaria'"> Bulgara </span></p>
              <p><span v-if="value.passport == 'Burkinish'">Burkínes</span><span v-else-if="value.passport == 'Burkínes'">Burkínes </span></p>
              <p><span v-if="value.passport == 'Burundesa'"> Burundesa </span></p>
              <p><span v-if="value.passport == 'Butanesa'"> Butanésa </span><span v-else-if="value.passport == 'Butanésa'">Butanésa </span></p>
              <p><span v-if="value.passport == 'Caboverdian'"> Caboverdiana </span><span v-else-if="value.passport == 'Caboverdiana'">Caboverdiana</span></p>
              <p><span v-if="value.passport == 'Cambodia'"> Camboyana </span><span v-else-if="value.passport == 'Camboyana'">Camboyana </span></p>
              <p><span v-if="value.passport == 'Cameroonian'"> Camerunesa </span><span v-else-if="value.passport == 'Camerunesa'">Camerunesa </span></p>
              <p><span v-if="value.passport == 'Canadian'"> Canadiense </span><span v-else-if="value.passport == 'Canadiense'">Canadiense </span></p>
              <p><span v-if="value.passport == 'Catari'"> Catari </span></p>
              <p><span v-if="value.passport == 'Chadiana'"> Chadiana </span></p>
              <p><span v-if="value.passport == 'Chilean'"> Chile </span><span v-else-if="value.passport == 'Chilena'">Chilena </span></p>
              <p><span v-if="value.passport == 'China'"> China </span></p>
              <p><span v-if="value.passport == 'Cypriot'"> Chipriota </span><span v-else-if="value.passport == 'Chipriota'">Chipriota </span></p>
              <p><span v-if="value.passport == 'Vatican'"> Vaticana </span><span v-else-if="value.passport == 'Vaticana'">Vaticana </span></p>
              <p><span v-if="value.passport == 'Colombian'"> Colombiana </span><span v-else-if="value.passport == 'Colombiana'">Colombiana </span></p>
              <p><span v-if="value.passport == 'Comorenian'"> Comorense </span><span v-else-if="value.passport == 'Comorense'">Comorense </span></p>
              <p><span v-if="value.passport == 'North Korean'"> Norcoreana </span><span v-else-if="value.passport == 'Norcoreana'">Norcoreana </span></p>
              <p><span v-if="value.passport == 'South Korean'"> Surcoreana </span><span v-else-if="value.passport == 'Surcoreana'">Surcoreana </span></p>
              <p><span v-if="value.passport == 'Ivory'"> Marfileña </span><span v-else-if="value.passport == 'Marfileña'">Marfileña </span></p>
              <p><span v-if="value.passport == 'Costarican'"> Costarricense</span><span v-else-if="value.passport == 'Costarricense'">Costarricense </span></p>
              <p><span v-if="value.passport == 'Croatian'"> Croata </span><span v-else-if="value.passport == 'Croata'">Croata </span></p>
              <p><span v-if="value.passport == 'Cuban'"> Cuba </span><span v-else-if="value.passport == 'Cuabana'">Cuabana </span></p>
              <p><span v-if="value.passport == 'Danesa'"> Danésa </span><span v-else-if="value.passport == 'Danésa'">Danésa </span></p>
              <p><span v-if="value.passport == 'Dominiquese'"> Dominiqués </span><span v-else-if="value.passport == 'Dominiqués'">Dominiqués </span></p>
              <p><span v-if="value.passport == 'Ecuadorian'"> Ecuatorian </span><span v-else-if="value.passport == 'Ecuatorian'">Ecuatorian </span></p>
              <p><span v-if="value.passport == 'Egyptian'"> Egipcia </span><span v-else-if="value.passport == 'Egipcia'">Egipcia </span></p>
              <p><span v-if="value.passport == 'Salvadoreña'">Salvadoreña </span></p>
              <p><span v-if="value.passport == 'Emirate'"> Emiratí </span><span v-else-if="value.passport == 'Emiratos Árabes Unidos'">Emiratí </span></p>
              <p><span v-if="value.passport == 'Eritrea'"> Eritrea </span></p>
              <p><span v-if="value.passport == 'England'"> Ingles </span><span v-else-if="value.passport == 'Ingles'">Ingles </span></p>
              <p><span v-if="value.passport == 'Slovak'"> Eslovaca </span><span v-else-if="value.passport == 'Eslovaca'">Eslovaca </span></p>
              <p><span v-if="value.passport == 'Slovenian'"> Eslovena </span><span v-else-if="value.passport == 'Eslovena'">Eslovena </span></p>
              <p><span v-if="value.passport == 'Spanish'"> Española </span><span v-else-if="value.passport == 'Española'">Española </span></p>
              <p><span v-if="value.passport == 'U.S'"> Estadounidense </span><span v-else-if="value.passport == 'Estadounidense'">Estadounidense </span></p>
              <p><span v-if="value.passport == 'Estonia'"> Estonia </span></p>
              <p><span v-if="value.passport == 'Ethiopian'"> Etíope </span><span v-else-if="value.passport == 'Etíope'">Etíope </span></p>
              <p><span v-if="value.passport == 'Filipina'"> Filipina </span></p>
              <p><span v-if="value.passport == 'Finlandesa'"> Finlandesa </span></p>
              <p><span v-if="value.passport == 'Fiyiana'"> Fiyiana </span></p>
              <p><span v-if="value.passport == 'French'"> Francésa </span><span v-else-if="value.passport == 'Francésa'">Francésa </span></p>
              <p><span v-if="value.passport == 'Gabonesa'"> Gabonésa </span><span v-else-if="value.passport == 'Gabonésa'">Gabonésa </span></p>
              <p><span v-if="value.passport == 'Gambiana'"> Gambiana </span></p>
              <p><span v-if="value.passport == 'Georgiana'"> Georgiana </span></p>
              <p><span v-if="value.passport == 'Gibraltareña'"> Gibraltareña </span></p>
              <p><span v-if="value.passport == 'Ghanesa'"> Ghanésa </span><span v-else-if="value.passport == 'Ghanésa'">Ghanésa </span></p>
              <p><span v-if="value.passport == 'Granadina'"> Granadina </span></p>
              <p><span v-if="value.passport == 'Griega'"> Griega </span></p>
              <p><span v-if="value.passport == 'Greenlandesa'"> Groelandésa </span><span v-else-if="value.passport == 'Groelandésa'">Groelandésa </span></p>
              <p><span v-if="value.passport == 'Guatemalteca'"> Guatemalteca </span></p>
              <p><span v-if="value.passport == 'Ecuatoguineana'"> Ecuatoguineana </span>
              <p><span v-if="value.passport == 'Guineana'"> Guineana </span></p>
              <p><span v-if="value.passport == 'Guineana'"> Guineana </span></p>
              <p><span v-if="value.passport == 'Guyanese'"> Guyanesa </span><span v-else-if="value.passport == 'Guyanesa'">Guyanesa </span></p>
              <p><span v-if="value.passport == 'Haitian'"> Haitiana </span><span v-else-if="value.passport == 'Haitiana'">Haitiana </span></p>
              <p><span v-if="value.passport == 'Honduran'"> Hondureña </span><span v-else-if="value.passport == 'Hondureña'">Hondureña </span></p>
              <p><span v-if="value.passport == 'Hungarian'"> Húngara </span><span v-else-if="value.passport == 'Húngara'">Húngara </span></p>
              <p><span v-if="value.passport == 'Hindu'"> Hindú </span><span v-else-if="value.passport == 'Hindú'">Hindú </span></p>
              <p><span v-if="value.passport == 'Indonesia'"> Indonesia </span></p>
              <p><span v-if="value.passport == 'Iraqi'"> Iraquí </span><span v-else-if="value.passport == 'Iraquí'">Iraquí </span></p>
              <p><span v-if="value.passport == 'Iranian'"> Iraní </span><span v-else-if="value.passport == 'Irán'">Iraní </span></p>
              <p><span v-if="value.passport == 'Irish'"> Irlandésa </span><span v-else-if="value.passport == 'Irlandésa'">Irlandésa </span></p>
              <p><span v-if="value.passport == 'Iceland'"> Islandésa </span><span v-else-if="value.passport == 'Islandésa'">Islandésa </span></p>
              <p><span v-if="value.passport == 'Cookiana'"> Cookiana </span></p>
              <p><span v-if="value.passport == 'Marshalesa'"> Marshalésa </span><span v-else-if="value.passport == 'Marshalésa'">Marshalésa </span></p>
              <p><span v-if="value.passport == 'Salomonia'"> Salomonense </span><span v-else-if="value.passport == 'Salomonense'"> Salomonense </span></p>
              <p><span v-if="value.passport == 'Israeli'"> Israelí </span><span v-else-if="value.passport == 'Israelí'"> Israelí </span></p>
              <p><span v-if="value.passport == 'Italian'"> Italiana </span><span v-else-if="value.passport == 'Italiana'">Italiana </span></p>
              <p><span v-if="value.passport == 'Jamaiquina'"> Jamaiquina </span></p>
              <p><span v-if="value.passport == 'Japanese'"> Japonésa </span><span v-else-if="value.passport == 'Japonésa'">Japonésa </span></p>
              <p><span v-if="value.passport == 'Jordana'"> Jordana </span></p>
              <p><span v-if="value.passport == 'Kazaja'"> Kazaja </span></p>
              <p><span v-if="value.passport == 'Keniata'"> Keniata </span></p>
              <p><span v-if="value.passport == 'Kiribatiana'"> Kiribatiana </span></p>
              <p><span v-if="value.passport == 'Kuwaiti'"> Kuwaiti </span></p>
              <p><span v-if="value.passport == 'Laosiana'"> Laosiana </span></p>
              <p><span v-if="value.passport == 'Lesotense'"> Lesotense </span></p>
              <p><span v-if="value.passport == 'Latvia'"> Letona </span><span v-else-if="value.passport == 'Letona'">Letona </span></p>
              <p><span v-if="value.passport == 'Lebanese'"> Libanésa </span><span v-else-if="value.passport == 'Libanésa'">Libanésa </span></p>
              <p><span v-if="value.passport == 'Liberiana'"> Liberiana </span></p>
              <p><span v-if="value.passport == 'Liechtensteiniana'"> Liechtensteiniana </span></p>
              <p><span v-if="value.passport == 'Lituania'"> Lituania </span></p>
              <p><span v-if="value.passport == 'Luxemburguesa'"> Luxemburguésa </span><span v-else-if="value.passport == 'Luxemburguésa'">Luxemburguésa </span></p>
              <p><span v-if="value.passport == 'Malgache'"> Malgache </span></p>
              <p><span v-if="value.passport == 'Malasia'"> Malasia </span></p>
              <p><span v-if="value.passport == 'Malaui'"> Malaui </span><span v-else-if="value.passport == 'Malauí'">Malauí </span></p>
              <p><span v-if="value.passport == 'Maldivas'"> Maldivas </span></p>
              <p><span v-if="value.passport == 'Maliensa'"> Maliense </span><span v-else-if="value.passport == 'Maliense'">Maliense </span></p>
              <p><span v-if="value.passport == 'Maltesa'"> Maltésa </span><span v-else-if="value.passport == 'Maltésa'">Maltésa </span></p>
              <p><span v-if="value.passport == 'Marroqui'"> Marroqui </span></p>
              <p><span v-if="value.passport == 'Martiniques'"> Martiniqués </span><span v-else-if="value.passport == 'Martiniqués'">Martiniqués </span></p>
              <p><span v-if="value.passport == 'Maurciana'"> Maurciana </span></p>
              <p><span v-if="value.passport == 'Mauritania'"> Mauritania </span></p>
              <p><span v-if="value.passport == 'Mexican'"> Mexicana </span><span v-else-if="value.passport == 'Mexicana'">Mexicana </span></p>
              <p><span v-if="value.passport == 'Micronesia'"> Micronesia </span></p>
              <p><span v-if="value.passport == 'Moldova'"> Moldava </span><span v-else-if="value.passport == 'Moldava'">Moldava </span></p>
              <p><span v-if="value.passport == 'Monegasca'"> Monegasca </span></p>
              <p><span v-if="value.passport == 'Mongola'"> Mongola </span></p>
              <p><span v-if="value.passport == 'Montegrina'"> Montegrina </span></p>
              <p><span v-if="value.passport == 'Mozambiqueña'"> Mozambiqueña </span></p>
              <p><span v-if="value.passport == 'Namibia'"> Namibia </span></p>
              <p><span v-if="value.passport == 'Nauruana'"> Nauruana </span></p>
              <p><span v-if="value.passport == 'Nepali'"> Nepal </span><span v-else-if="value.passport == 'Nepalí'">Nepalí </span></p>
              <p><span v-if="value.passport == 'Nicaraguan'"> Nicaraguense </span><span v-else-if="value.passport == 'Nicaraguense'">Nicaraguense </span></p>
              <p><span v-if="value.passport == 'Nigerina'"> Nigerina </span></p>
              <p><span v-if="value.passport == 'Norway'"> Noruega </span><span v-else-if="value.passport == 'Noruega'">Noruega </span></p>
              <p><span v-if="value.passport == 'Neozeolandesa'"> Neozeolandésa </span><span v-else-if="value.passport == 'Neozeolandésa'">Neozeolandésa </span></p>
              <p><span v-if="value.passport == 'Omani'"> Omaní </span><span v-else-if="value.passport == 'Omaní'">Omaní </span></p>
              <p><span v-if="value.passport == 'Netherlands'"> Neelandésa </span><span v-else-if="value.passport == 'Neelandésa'"> Neelandésa </span></p>
              <p><span v-if="value.passport == 'Pakistani'"> Pakistaní </span><span v-else-if="value.passport == 'Pakistaní'">Pakistaní </span></p>
              <p><span v-if="value.passport == 'Palauana'"> Palauana </span></p>
              <p><span v-if="value.passport == 'Palestine'"> Palestina </span><span v-else-if="value.passport == 'Palestina'">Palestina </span></p>
              <p><span v-if="value.passport == 'Panamanian'"> Panameña </span><span v-else-if="value.passport == 'Panameña'">Panameña </span></p>
              <p><span v-if="value.passport == 'Papuan'"> Papú </span><span v-else-if="value.passport == 'Papú'">Papú </span></p>
              <p><span v-if="value.passport == 'Paraguayan'"> Paraguaya </span><span v-else-if="value.passport == 'Paraguaya'">Paraguaya </span></p>
              <p><span v-if="value.passport == 'Peruvian'"> Peruana </span><span v-else-if="value.passport == 'Peruana'">Peruana </span></p>
              <p><span v-if="value.passport == 'Polish'"> Polaca </span><span v-else-if="value.passport == 'Polaca'">Polaca </span></p>
              <p><span v-if="value.passport == 'Portuguese'"> Portugal </span><span v-else-if="value.passport == 'Portuguésa'">Portuguésa </span></p>
              <p><span v-if="value.passport == 'Puertorican'">Puertorriqueña </span><span v-else-if="value.passport == 'Puertorriqueña'">Puertorriqueña </span></p>
              <p><span v-if="value.passport == 'British'"> Británica </span><span v-else-if="value.passport == 'Británica'">Británica </span></p>
              <p><span v-if="value.passport == 'Centralafrincan'"> Centroafriacana </span><span v-else-if="value.passport == 'Centroafriacana'">Centroafriacana </span></p>
              <p><span v-if="value.passport == 'Czech'">Checa </span><span v-else-if="value.passport == 'Checa'">Checa </span></p>
              <p><span v-if="value.passport == 'Macedonia'">Macedonia </span></p>
              <p><span v-if="value.passport == 'Congoleña'">Congoleña </span></p>
              <p><span v-if="value.passport == 'Congoleña'">Congoleña </span></p>
              <p><span v-if="value.passport == 'Dominican'">Dominicana </span><span v-else-if="value.passport == 'Dominicana'">Dominicana </span></p>
              <p><span v-if="value.passport == 'South African'">Sudafricana </span><span v-else-if="value.passport == 'Sudafricana'">Sudafricana </span></p>
              <p><span v-if="value.passport == 'Rwanda'"> Ruandésa </span><span v-else-if="value.passport == 'Ruandésa'">Ruandésa </span></p>
              <p><span v-if="value.passport == 'Romanian'"> Rumana </span><span v-else-if="value.passport == 'Rumana'">Rumana </span></p>
              <p><span v-if="value.passport == 'Russian'"> Rusa </span><span v-else-if="value.passport == 'Rusa'">Rusa </span></p>
              <p><span v-if="value.passport == 'Samoana'"> Samoana </span></p>
              <p><span v-if="value.passport == 'Cristobaleña'"> Cristobaleña </span></p>
              <p><span v-if="value.passport == 'Sanmarinense'"> Sanmarinense </span></p>
              <p><span v-if="value.passport == 'Sanvicentina'"> Sanvicentina </span></p>
              <p><span v-if="value.passport == 'Santalucense'"> Santalucense </span></p>
              <p><span v-if="value.passport == 'Senegalesa'"> Senegalésa </span><span v-else-if="value.passport == 'Senegalésa'">Senegalésa </span></p>
              <p><span v-if="value.passport == 'Serbia'"> Serbia </span></p>
              <p><span v-if="value.passport == 'Seychellense'"> Seychellense </span></p>
              <p><span v-if="value.passport == 'Sierraleonesa'"> Sierraleonésa </span><span v-else-if="value.passport == 'Sierraleonésa'">Sierraleonésa </span></p>
              <p><span v-if="value.passport == 'Singaporean'"> Singapurense </span><span v-else-if="value.passport == 'Singapurense'">Singapurense </span></p>
              <p><span v-if="value.passport == 'Syria'"> Siria </span><span v-else-if="value.passport == 'Siria'">Siria </span></p>
              <p><span v-if="value.passport == 'Somali'"> Somalí </span><span v-else-if="value.passport == 'Somalí'">Somalí </span></p>
              <p><span v-if="value.passport == 'Ceilanesa'"> Ceilanésa </span><span v-else-if="value.passport == 'Ceilanésa'">Ceilanésa </span></p>
              <p><span v-if="value.passport == 'Suazi'"> Suazi </span></p>
              <p><span v-if="value.passport == 'South sudanesa'"> Surdanésa </span><span v-else-if="value.passport == 'Surdanésa'">Surdanésa </span></p>
              <p><span v-if="value.passport == 'Sudanesa'"> Sudanésa </span><span v-else-if="value.passport == 'Sudanésa'">Sudanésa </span></p>
              <p><span v-if="value.passport == 'Swedish'"> Sueca </span><span v-else-if="value.passport == 'Sueca'">Sueca </span></p>
              <p><span v-if="value.passport == 'Switzerland'"> Suiza </span><span v-else-if="value.passport == 'Suiza'">Suiza </span></p>
              <p><span v-if="value.passport == 'Suriname'"> Surinamesa </span><span v-else-if="value.passport == 'Surinamesa'">Surinamesa </span></p>
              <p><span v-if="value.passport == 'Thai'"> Tailandésa </span><span v-else-if="value.passport == 'Tailandésa'">Tailandésa </span></p>
              <p><span v-if="value.passport == 'Tanzana'"> Tanzana </span></p>
              <p><span v-if="value.passport == 'Tajika'"> Tayica </span><span v-else-if="value.passport == 'Tayica'">Tayica </span></p>
              <p><span v-if="value.passport == 'Timorense'"> Timorense </span></p>
              <p><span v-if="value.passport == 'Togolesa'"> Togolésa </span><span v-else-if="value.passport == 'Togolésa'">Togolésa </span></p>
              <p><span v-if="value.passport == 'Tongana'"> Tongana </span></p>
              <p><span v-if="value.passport == 'Trinitense'"> Trinitense </span></p>
              <p><span v-if="value.passport == 'Tunisian'"> Tunecina </span><span v-else-if="value.passport == 'Tunecina'">Tunecina </span></p>
              <p><span v-if="value.passport == 'Turcomana'"> Turcomana </span></p>
              <p><span v-if="value.passport == 'Turkish'"> Turca </span><span v-else-if="value.passport == 'Turca'">Turca </span></p>
              <p><span v-if="value.passport == 'Tuvaluana'"> Tuvaluana </span></p>
              <p><span v-if="value.passport == 'Ukraine'"> Ucraniana </span><span v-else-if="value.passport == 'Ucraniana'">Ucraniana </span></p>
              <p><span v-if="value.passport == 'Ugandesa'"> Ugandésa </span><span v-else-if="value.passport == 'Ugandésa'">Ugandésa </span></p>
              <p><span v-if="value.passport == 'Uruguaya'"> Uruguaya </span></p>
              <p><span v-if="value.passport == 'Uzbeka'"> Uzbeka </span></p>
              <p><span v-if="value.passport == 'Vanuatuense'"> Vanuatuense </span></p>
              <p><span v-if="value.passport == 'Venezuelan'"> Venezolana </span><span v-else-if="value.passport == 'Venezolana'">Venezolana </span></p>
              <p><span v-if="value.passport == 'Vietnamese'"> Vietnamita </span><span v-else-if="value.passport == 'Vietnamita'">Vietnamita </span></p>
              <p><span v-if="value.passport == 'Yemeni'"> Yemení </span><span v-else-if="value.passport == 'Yemení'">Yemení </span></p>
              <p><span v-if="value.passport == 'Djibouti'"> Djibouti </span></p>
              <p><span v-if="value.passport == 'Zambian'"> Zambiana </span><span v-else-if="value.passport == 'Zambiana'">Zambiana </span></p>
              <p><span v-if="value.passport == 'Zimbabwean'"> Zimbauense </span><span v-else-if="value.passport == 'Zimbauense'">Zimbauense </span></p>            
            </td>
            <td v-else  v-on:click="handleRow(index)" class="show-desktop-d" data-toggle="collapse" :data-target="'#detail' + index">
              <p><span v-if="value.passport == 'Afgana'"> Afghan</span><span v-else-if="value.passport == 'Afghan'">Afghan </span></p>
              <p><span v-if="value.passport == 'Albanesa'">Albanian  </span><span v-else-if="value.passport == 'Albanian'">Albanian </span></p>
              <p><span v-if="value.passport == 'Alemana'"> German </span><span v-else-if="value.passport == 'German'">German </span></p>
              <p><span v-if="value.passport == 'Angoleaña'">Angolan  </span><span v-else-if="value.passport == 'Angolan'">Angolan </span></p>
              <p><span v-if="value.passport == 'Antiguana'"> Antiguana </span></p>
              <p><span v-if="value.passport == 'Saudí'"> Saudi </span><span v-else-if="value.passport == 'Saudi'">Saudi </span></p>
              <p><span v-if="value.passport == 'Argelina'"> Algerian  </span><span v-else-if="value.passport == 'Algerian'">Algerian </span></p>
              <p><span v-if="value.passport == 'Argentina'"> Argentine </span><span v-else-if="value.passport == 'Argentine'">Argentine </span></p>
              <p><span v-if="value.passport == 'Armenia'"> Armenia </span></p>
              <p><span v-if="value.passport == 'Arubeña'">Aruban  </span><span v-else-if="value.passport == 'Aruban'">Aruban </span></p>
              <p><span v-if="value.passport == 'Australia'"> Australia </span></p>
              <p><span v-if="value.passport == 'Austriaca'">Austrain  </span><span v-else-if="value.passport == 'Austrain'">Austrain </span></p>
              <p><span v-if="value.passport == 'Azerbaiyana'"> Azerbaiyana </span></p>
              <p><span v-if="value.passport == 'Bahameña'"> Bahaman  </span><span v-else-if="value.passport == 'Bahaman'">Bahaman </span></p>
              <p><span v-if="value.passport == 'Bangladesí'"> Bangkladesyes  </span><span v-else-if="value.passport == 'Bangkladesyes'">Bangkladesyes </span></p>
              <p><span v-if="value.passport == 'Barbadense'"> Barbadense </span></p>
              <p><span v-if="value.passport == 'Bareiní'"> Bareiní </span></p>
              <p><span v-if="value.passport == 'Belga'"> Belgian  </span><span v-else-if="value.passport == 'Belgian'">Belgian </span></p>
              <p><span v-if="value.passport == 'Beliceña'"> Belize  </span><span v-else-if="value.passport == 'Belize'">Belize </span></p>
              <p><span v-if="value.passport == 'Beninesa'"> Beninese  </span><span v-else-if="value.passport == 'Beninese'">Beninese </span></p>
              <p><span v-if="value.passport == 'Bielorrusa'"> Belarus  </span><span v-else-if="value.passport == 'Belarus'">Belarus </span></p>
              <p><span v-if="value.passport == 'Birmana'"> Burma  </span><span v-else-if="value.passport == 'Burma'">Burma </span></p>
              <p><span v-if="value.passport == 'Boliviana'"> Boliviana </span></p>
              <p><span v-if="value.passport == 'Bosnia'">Bosnia </span></p>
              <p><span v-if="value.passport == 'Botswana'"> Botswana </span></p>
              <p><span v-if="value.passport == 'Brasileña'"> Brazilian  </span><span v-else-if="value.passport == 'Brazilian'">Brazilian </span></p>
              <p><span v-if="value.passport == 'Bruneana'"> Bruneana </span></p>
              <p><span v-if="value.passport == 'Bulgaria'"> Bulgara </span></p>
              <p><span v-if="value.passport == 'Burkínes'">Burkinish </span><span v-else-if="value.passport == 'Burkinish'">Burkinish </span></p>
              <p><span v-if="value.passport == 'Burundesa'"> Burundesa </span></p>
              <p><span v-if="value.passport == 'Butanésa'"> Butanesa  </span><span v-else-if="value.passport == 'Butanesa'">Butanesa </span></p>
              <p><span v-if="value.passport == 'Caboverdiana'"> Caboverdian  </span><span v-else-if="value.passport == 'Caboverdian'">Caboverdian</span></p>
              <p><span v-if="value.passport == 'Camboyana'">Cambodia   </span><span v-else-if="value.passport == 'Cambodia'">Cambodia </span></p>
              <p><span v-if="value.passport == 'Camerunesa'"> Cameroonian  </span><span v-else-if="value.passport == 'Cameroonian'">Cameroonian </span></p>
              <p><span v-if="value.passport == 'Canadiense'"> Canadian  </span><span v-else-if="value.passport == 'Canadian'">Canadian </span></p>
              <p><span v-if="value.passport == 'Catari'"> Catari </span></p>
              <p><span v-if="value.passport == 'Chadiana'"> Chadiana </span></p>
              <p><span v-if="value.passport == 'Chile'"> Chilean  </span><span v-else-if="value.passport == 'Chilean'">Chilean </span></p>
              <p><span v-if="value.passport == 'China'"> China </span></p>
              <p><span v-if="value.passport == 'Chipriota'"> Cypriot  </span><span v-else-if="value.passport == 'Cypriot'">Cypriot </span></p>
              <p><span v-if="value.passport == 'Vaticana'"> Vatican  </span><span v-else-if="value.passport == 'Vatican'">Vatican </span></p>
              <p><span v-if="value.passport == 'Colombiana'"> Colombian  </span><span v-else-if="value.passport == 'Colombian'">Colombian </span></p>
              <p><span v-if="value.passport == 'Comorense'"> Comorenian  </span><span v-else-if="value.passport == 'Comorenian'">Comorenian </span></p>
              <p><span v-if="value.passport == 'Norcoreana'"> North Korean  </span><span v-else-if="value.passport == 'North Korean'">North Korean </span></p>
              <p><span v-if="value.passport == 'Surcoreana'"> South Korean  </span><span v-else-if="value.passport == 'South Korean'">South Korean </span></p>
              <p><span v-if="value.passport == 'Marfileña'"> Ivory  </span><span v-else-if="value.passport == 'Ivory'">Ivory </span></p>
              <p><span v-if="value.passport == 'Costarricense'"> Costarican </span><span v-else-if="value.passport == 'Costarican'">Costarican </span></p>
              <p><span v-if="value.passport == 'Croata'"> Croatian  </span><span v-else-if="value.passport == 'Croatian'">Croatian </span></p>
              <p><span v-if="value.passport == 'Cuabana'"> Cuban </span><span v-else-if="value.passport == 'Cuban'">Cuban </span></p>
              <p><span v-if="value.passport == 'Danésa'"> Danesa  </span><span v-else-if="value.passport == 'Danesa'">Danesa </span></p>
              <p><span v-if="value.passport == 'Dominiquese'"> Dominiquese  </span><span v-else-if="value.passport == 'Dominiqués'">Dominiqués </span></p>
              <p><span v-if="value.passport == 'Ecuatorian'"> Ecuadorian  </span><span v-else-if="value.passport == 'Ecuadorian'">Ecuadorian </span></p>
              <p><span v-if="value.passport == 'Egipcia'"> Egyptian  </span><span v-else-if="value.passport == 'Egyptian'">Egyptian </span></p>
              <p><span v-if="value.passport == 'Salvadoreña'">Salvadoreña </span></p>
              <p><span v-if="value.passport == 'Emirate'"> Emiratí </span><span v-else-if="value.passport == 'Emiratí'">Emiratí </span></p>
              <p><span v-if="value.passport == 'Eritrea'"> Eritrea </span></p>
              <p><span v-if="value.passport == 'Ingles'"> England  </span><span v-else-if="value.passport == 'England'">England </span></p>
              <p><span v-if="value.passport == 'Eslovaca'"> Slovak  </span><span v-else-if="value.passport == 'Slovak'">Slovak </span></p>
              <p><span v-if="value.passport == 'Eslovena'"> Slovenian  </span><span v-else-if="value.passport == 'Slovenian'">Slovenian </span></p>
              <p><span v-if="value.passport == 'Española'"> Spanish  </span><span v-else-if="value.passport == 'Spanish'">Spanish </span></p>
              <p><span v-if="value.passport == 'Estadounidense'"> U.S  </span><span v-else-if="value.passport == 'U.S'">U.S </span></p>
              <p><span v-if="value.passport == 'Estonia'"> Estonia </span></p>
              <p><span v-if="value.passport == 'Etíope'"> Ethiopian  </span><span v-else-if="value.passport == 'Ethiopian'">Ethiopian </span></p>
              <p><span v-if="value.passport == 'Filipina'"> Filipina </span></p>
              <p><span v-if="value.passport == 'Finlandesa'"> Finlandesa </span></p>
              <p><span v-if="value.passport == 'Fiyiana'"> Fiyiana </span></p>
              <p><span v-if="value.passport == 'Francésa'"> French </span><span v-else-if="value.passport == 'French'">French </span></p>
              <p><span v-if="value.passport == 'Gabonésa'"> Gabonesa </span><span v-else-if="value.passport == 'Gabonesa'">Gabonesa </span></p>
              <p><span v-if="value.passport == 'Gambiana'"> Gambiana </span></p>
              <p><span v-if="value.passport == 'Georgiana'"> Georgiana </span></p>
              <p><span v-if="value.passport == 'Gibraltareña'"> Gibraltareña </span></p>
              <p><span v-if="value.passport == 'Ghanésa'"> Ghanesa </span><span v-else-if="value.passport == 'Ghanesa'">Ghanesa </span></p>
              <p><span v-if="value.passport == 'Granadina'"> Granadina </span></p>
              <p><span v-if="value.passport == 'Griega'"> Griega </span></p>
              <p><span v-if="value.passport == 'Groelandésa'">Greenlandesa   </span><span v-else-if="value.passport == 'Greenlandesa'">Greenlandesa </span></p>
              <p><span v-if="value.passport == 'Guatemalteca'"> Guatemalteca </span></p>
              <p><span v-if="value.passport == 'Ecuatoguineana'"> Ecuatoguineana </span>
              <p><span v-if="value.passport == 'Guineana'"> Guineana </span></p>
              <p><span v-if="value.passport == 'Guineana'"> Guineana </span></p>
              <p><span v-if="value.passport == 'Guyanesa'"> Guyanese  </span><span v-else-if="value.passport == 'Guyanese'">Guyanese </span></p>
              <p><span v-if="value.passport == 'Haitiana'"> Haitian </span><span v-else-if="value.passport == 'Haitian'">Haitian </span></p>
              <p><span v-if="value.passport == 'Hondureña'"> Honduran  </span><span v-else-if="value.passport == 'Honduran'">Honduran </span></p>
              <p><span v-if="value.passport == 'Húngara'"> Hungarian  </span><span v-else-if="value.passport == 'Hungarian'">Hungarian </span></p>
              <p><span v-if="value.passport == 'Hindú'"> Hindu </span><span v-else-if="value.passport == 'Hindu'">Hindu </span></p>
              <p><span v-if="value.passport == 'Indonesia'"> Indonesia </span></p>
              <p><span v-if="value.passport == 'Iraquí'"> Iraqi  </span><span v-else-if="value.passport == 'Iraqi'">Iraqi </span></p>
              <p><span v-if="value.passport == 'Iraní'"> Iranian  </span><span v-else-if="value.passport == 'Iranian'">Iranian </span></p>
              <p><span v-if="value.passport == 'Irlandésa'"> Irish  </span><span v-else-if="value.passport == 'Irish'">Irish </span></p>
              <p><span v-if="value.passport == 'Islandésa'"> Iceland  </span><span v-else-if="value.passport == 'Iceland'">Iceland </span></p>
              <p><span v-if="value.passport == 'Cookiana'"> Cookiana </span></p>
              <p><span v-if="value.passport == 'Marshalésa'"> Marshalesa  </span><span v-else-if="value.passport == 'Marshalesa'">Marshalesa </span></p>
              <p><span v-if="value.passport == 'Salomonense'"> Salomonia </span><span v-else-if="value.passport == 'Salomonia'"> Salomonia </span></p>
              <p><span v-if="value.passport == 'Israelí'"> Israeli </span><span v-else-if="value.passport == 'Israeli'"> Israeli </span></p>
              <p><span v-if="value.passport == 'Italiana'"> Italian  </span><span v-else-if="value.passport == 'Italian'">Italian </span></p>
              <p><span v-if="value.passport == 'Jamaiquina'"> Jamaiquina </span></p>
              <p><span v-if="value.passport == 'Japonésa'"> Japanese  </span><span v-else-if="value.passport == 'Japanese'">Japanese </span></p>
              <p><span v-if="value.passport == 'Jordana'"> Jordana </span></p>
              <p><span v-if="value.passport == 'Kazaja'"> Kazaja </span></p>
              <p><span v-if="value.passport == 'Keniata'"> Keniata </span></p>
              <p><span v-if="value.passport == 'Kiribatiana'"> Kiribatiana </span></p>
              <p><span v-if="value.passport == 'Kuwaiti'"> Kuwaiti </span></p>
              <p><span v-if="value.passport == 'Laosiana'"> Laosiana </span></p>
              <p><span v-if="value.passport == 'Lesotense'"> Lesotense </span></p>
              <p><span v-if="value.passport == 'Letona'"> Latvia  </span><span v-else-if="value.passport == 'Latvia'">Latvia </span></p>
              <p><span v-if="value.passport == 'Libanésa'"> Lebanese  </span><span v-else-if="value.passport == 'Lebanese'">Lebanese </span></p>
              <p><span v-if="value.passport == 'Liberiana'"> Liberiana </span></p>
              <p><span v-if="value.passport == 'Liechtensteiniana'"> Liechtensteiniana </span></p>
              <p><span v-if="value.passport == 'Lituania'"> Lituania </span></p>
              <p><span v-if="value.passport == 'Luxemburguésa'"> Luxemburguesa  </span><span v-else-if="value.passport == 'Luxemburguesa'">Luxemburguesa </span></p>
              <p><span v-if="value.passport == 'Malgache'"> Malgache </span></p>
              <p><span v-if="value.passport == 'Malasia'"> Malasia </span></p>
              <p><span v-if="value.passport == 'Malauí'"> Malaui  </span><span v-else-if="value.passport == 'Malaui'">Malaui </span></p>
              <p><span v-if="value.passport == 'Maldivas'"> Maldivas </span></p>
              <p><span v-if="value.passport == 'Maliensa'"> Maliense   </span><span v-else-if="value.passport == 'Maliense'">Maliense </span></p>
              <p><span v-if="value.passport == 'Maltésa'"> Maltesa </span><span v-else-if="value.passport == 'Maltesa'">Maltesa </span></p>
              <p><span v-if="value.passport == 'Marroqui'"> Marroqui </span></p>
              <p><span v-if="value.passport == 'Martiniqués'"> Martiniques </span><span v-else-if="value.passport == 'Martiniques'">Martiniques </span></p>
              <p><span v-if="value.passport == 'Maurciana'"> Maurciana </span></p>
              <p><span v-if="value.passport == 'Mauritania'"> Mauritania </span></p>
              <p><span v-if="value.passport == 'Mexicana'"> Mexican </span><span v-else-if="value.passport == 'Mexican'">Mexican </span></p>
              <p><span v-if="value.passport == 'Micronesia'"> Micronesia </span></p>
              <p><span v-if="value.passport == 'Moldava'"> Moldova  </span><span v-else-if="value.passport == 'Moldova'">Moldova </span></p>
              <p><span v-if="value.passport == 'Monegasca'"> Monegasca </span></p>
              <p><span v-if="value.passport == 'Mongola'"> Mongola </span></p>
              <p><span v-if="value.passport == 'Montegrina'"> Montegrina </span></p>
              <p><span v-if="value.passport == 'Mozambiqueña'"> Mozambiqueña </span></p>
              <p><span v-if="value.passport == 'Namibia'"> Namibia </span></p>
              <p><span v-if="value.passport == 'Nauruana'"> Nauruana </span></p>
              <p><span v-if="value.passport == 'Nepal'">Nepali  </span><span v-else-if="value.passport == 'Nepali'">Nepali </span></p>
              <p><span v-if="value.passport == 'Nicaraguense'"> Nicaraguan  </span><span v-else-if="value.passport == 'Nicaraguan'">Nicaraguan </span></p>
              <p><span v-if="value.passport == 'Nigerina'"> Nigerina </span></p>
              <p><span v-if="value.passport == 'Noruega'"> Norway  </span><span v-else-if="value.passport == 'Norway'">Norway </span></p>
              <p><span v-if="value.passport == 'Neozeolandésa'"> Neozeolandesa  </span><span v-else-if="value.passport == 'Neozeolandesa'">Neozeolandesa </span></p>
              <p><span v-if="value.passport == 'Omaní'"> Omani </span><span v-else-if="value.passport == 'Omani'">Omani </span></p>
              <p><span v-if="value.passport == 'Neelandésa'"> Netherlands  </span><span v-else-if="value.passport == 'Netherlands'"> Netherlands </span></p>
              <p><span v-if="value.passport == 'Pakistaní'"> Pakistani  </span><span v-else-if="value.passport == 'Pakistani'">Pakistani </span></p>
              <p><span v-if="value.passport == 'Palauana'"> Palauana </span></p>
              <p><span v-if="value.passport == 'Palestina'"> Palestine  </span><span v-else-if="value.passport == 'Palestine'">Palestine </span></p>
              <p><span v-if="value.passport == 'Panameña'"> Panamanian  </span><span v-else-if="value.passport == 'Panamanian'">Panamanian </span></p>
              <p><span v-if="value.passport == 'Papú'"> Papuan  </span><span v-else-if="value.passport == 'Papuan'">Papuan </span></p>
              <p><span v-if="value.passport == 'Paraguaya'"> Paraguayan </span><span v-else-if="value.passport == 'Paraguayan'">Paraguayan </span></p>
              <p><span v-if="value.passport == 'Peruana'"> Peruvian  </span><span v-else-if="value.passport == 'Peruvian'">Peruvian </span></p>
              <p><span v-if="value.passport == 'Polaca'"> Polish  </span><span v-else-if="value.passport == 'Polish'">Polish </span></p>
              <p><span v-if="value.passport == 'Portugal'"> Portuguese  </span><span v-else-if="value.passport == 'Portuguese'">Portuguese </span></p>
              <p><span v-if="value.passport == 'Puertorriqueña'">Puertorican  </span><span v-else-if="value.passport == 'Puertorican'">Puertorican </span></p>
              <p><span v-if="value.passport == 'Británica'">British  </span><span v-else-if="value.passport == 'British'">British </span></p>
              <p><span v-if="value.passport == 'Centroafriacana'"> Centralafrincan  </span><span v-else-if="value.passport == 'Centralafrincan'">Centralafrincan </span></p>
              <p><span v-if="value.passport == 'Checa'">Czech  </span><span v-else-if="value.passport == 'Czech'">Czech </span></p>
              <p><span v-if="value.passport == 'Macedonia'">Macedonia </span></p>
              <p><span v-if="value.passport == 'Congoleña'">Congoleña </span></p>
              <p><span v-if="value.passport == 'Congoleña'">Congoleña </span></p>
              <p><span v-if="value.passport == 'Dominicana'">Dominican </span><span v-else-if="value.passport == 'Dominican'">Dominican </span></p>
              <p><span v-if="value.passport == 'Sudafricana'">South African  </span><span v-else-if="value.passport == 'South African'">South African </span></p>
              <p><span v-if="value.passport == 'Ruandésa'">Rwanda   </span><span v-else-if="value.passport == 'Rwanda'">Rwanda </span></p>
              <p><span v-if="value.passport == 'Rumana'"> Romanian  </span><span v-else-if="value.passport == 'Romanian'">Romanian </span></p>
              <p><span v-if="value.passport == 'Rusa'"> Russian  </span><span v-else-if="value.passport == 'Russian'">Russian </span></p>
              <p><span v-if="value.passport == 'Samoana'"> Samoana </span></p>
              <p><span v-if="value.passport == 'Cristobaleña'"> Cristobaleña </span></p>
              <p><span v-if="value.passport == 'Sanmarinense'"> Sanmarinense </span></p>
              <p><span v-if="value.passport == 'Sanvicentina'"> Sanvicentina </span></p>
              <p><span v-if="value.passport == 'Santalucense'"> Santalucense </span></p>
              <p><span v-if="value.passport == 'Senegalésa'">Senegalesa  </span><span v-else-if="value.passport == 'Senegalesa'">Senegalesa </span></p>
              <p><span v-if="value.passport == 'Serbia'"> Serbia </span></p>
              <p><span v-if="value.passport == 'Seychellense'"> Seychellense </span></p>
              <p><span v-if="value.passport == 'Sierraleonésa'"> Sierraleonesa  </span><span v-else-if="value.passport == 'Sierraleonesa'">Sierraleonesa </span></p>
              <p><span v-if="value.passport == 'Singapurense'">Singaporean  </span><span v-else-if="value.passport == 'Singaporean'">Singaporean </span></p>
              <p><span v-if="value.passport == 'Siria'"> Syria  </span><span v-else-if="value.passport == 'Syria'">Syria </span></p>
              <p><span v-if="value.passport == 'Somalí'"> Somali </span><span v-else-if="value.passport == 'Somali'">Somali </span></p>
              <p><span v-if="value.passport == 'Ceilanesa'"> Ceilanésa </span><span v-else-if="value.passport == 'Ceilanésa'">Ceilanésa </span></p>
              <p><span v-if="value.passport == 'Suazi'"> Suazi </span></p>
              <p><span v-if="value.passport == 'Surdanésa'"> South sudanesa  </span><span v-else-if="value.passport == 'South sudanesa'">South sudanesa </span></p>
              <p><span v-if="value.passport == 'Sudanésa'"> Sudanesa  </span><span v-else-if="value.passport == 'Sudanesa'">Sudanesa </span></p>
              <p><span v-if="value.passport == 'Sueca'"> Swedish  </span><span v-else-if="value.passport == 'Swedish'">Swedish </span></p>
              <p><span v-if="value.passport == 'Suiza'"> Switzerland  </span><span v-else-if="value.passport == 'Switzerland'">Switzerland </span></p>
              <p><span v-if="value.passport == 'Surinamesa'"> Suriname  </span><span v-else-if="value.passport == 'Suriname'">Suriname </span></p>
              <p><span v-if="value.passport == 'Tailandésa'"> Thai  </span><span v-else-if="value.passport == 'Thai'">Thai </span></p>
              <p><span v-if="value.passport == 'Tanzana'"> Tanzana </span></p>
              <p><span v-if="value.passport == 'Tayica'"> Tajika  </span><span v-else-if="value.passport == 'Tajika'">Tajika </span></p>
              <p><span v-if="value.passport == 'Timorense'"> Timorense </span></p>
              <p><span v-if="value.passport == 'Togolésa'"> Togolesa  </span><span v-else-if="value.passport == 'Togolesa'">Togolesa </span></p>
              <p><span v-if="value.passport == 'Tongana'"> Tongana </span></p>
              <p><span v-if="value.passport == 'Trinitense'"> Trinitense </span></p>
              <p><span v-if="value.passport == 'Tunecina'"> Tunisian  </span><span v-else-if="value.passport == 'Tunisian'">Tunisian </span></p>
              <p><span v-if="value.passport == 'Turcomana'"> Turcomana </span></p>
              <p><span v-if="value.passport == 'Turca'"> Turkish  </span><span v-else-if="value.passport == 'Turkish'">Turkish </span></p>
              <p><span v-if="value.passport == 'Tuvaluana'"> Tuvaluana </span></p>
              <p><span v-if="value.passport == 'Ucraniana'"> Ukraine  </span><span v-else-if="value.passport == 'Ukraine'">Ukraine </span></p>
              <p><span v-if="value.passport == 'Ugandésa'"> Ugandesa </span><span v-else-if="value.passport == 'Ugandesa'">Ugandesa </span></p>
              <p><span v-if="value.passport == 'Uruguaya'"> Uruguaya </span></p>
              <p><span v-if="value.passport == 'Uzbeka'"> Uzbeka </span></p>
              <p><span v-if="value.passport == 'Vanuatuense'"> Vanuatuense </span></p>
              <p><span v-if="value.passport == 'Venezolana'"> Venezuelan  </span><span v-else-if="value.passport == 'Venezuelan'">Venezuelan </span></p>
              <p><span v-if="value.passport == 'Vietnamita'"> Vietnamese  </span><span v-else-if="value.passport == 'Vietnamese'">Vietnamese </span></p>
              <p><span v-if="value.passport == 'Yemení'"> Yemeni </span><span v-else-if="value.passport == 'Yemeni'">Yemeni </span></p>
              <p><span v-if="value.passport == 'Djibouti'"> Djibouti </span></p>
              <p><span v-if="value.passport == 'Zambiana'"> Zambian </span><span v-else-if="value.passport == 'Zambian'">Zambian </span></p>
              <p><span v-if="value.passport == 'Zimbauense'"> Zimbabwean  </span><span v-else-if="value.passport == 'Zimbabwean'">Zimbabwean </span></p>
            </td>
            <!--<td v-on:click="handleRow(index)" class="show-desktop-d" data-toggle="collapse" :data-target="'#detail' + index">{{value.foot}}</td>-->
            <td  v-if="$t('flag.flag') == 'es'" v-on:click="handleRow(index)" class="show-desktop-d" data-toggle="collapse" :data-target="'#detail' + index">
              <p v-if="value.foot == 'Left'">Izquierda</p><p v-else-if="value.foot == 'Izquierda'">Izquierda</p>
              <p v-if="value.foot == 'Right'">Derecha</p><p v-else-if="value.foot == 'Derecha'">Derecha</p>
              <p v-if="value.foot == 'Both'">Ambas</p><p v-else-if="value.foot == 'Ambas'">Ambas</p>
            </td>
            <td  v-else v-on:click="handleRow(index)" class="show-desktop-d" data-toggle="collapse" :data-target="'#detail' + index">
              <p v-if="value.foot == 'Izquierda'">Left</p><p v-else-if="value.foot == 'Left'">Left</p>
              <p v-if="value.foot == 'Derecha'">Right</p><p v-else-if="value.foot == 'Right'">Right</p>
              <p v-if="value.foot == 'Ambas'">Both</p><p v-else-if="value.foot == 'Both'">Both</p>
            </td>

            <td v-on:click="handleRow(index)" class="show-desktop-d" data-toggle="collapse" :data-target="'#detail' + index">{{value.height}}</td>
            <td v-on:click="handleRow(index)" class="show-desktop-d" data-toggle="collapse" :data-target="'#detail' + index">
              <p v-if="value.cost == 1">0 - 100k</p>
              <p v-if="value.cost == 2">100k - 300k</p>
              <p v-if="value.cost == 3">300k - 500k</p>
              <p v-if="value.cost == 4">> 500k</p>
              </td>
            <td>
              <button v-on:click="clean(value.objectId, '', index), selected = ''" class="delete_user"></button>
            </td>
          </tr>
          <tr :key="value.id" :id="'detail'+index" data-parent="#accordion" class="collapse">
            <td colspan="12" class="hiddenRow">
              <div class="accordian-body" >
                <template>
                  <article class="media">
                    <figure class="media-left l-r">
                      <div class="info-user">
                        <div class="c-user left-info">
                          <img class="image-play" v-bind:src="value.avatar"/>
                          <p class="title-name">{{value.firstName}} {{value.lastName}}}</p>
                          <small>{{ value.team }}<br></small>
                          <!--<button v-on:click="handleSelectItem(value.id)" class="btn-action"><img src="../assets/images/menu_btn.png"/>Agregar a una lista</button><br>-->
                          <button v-on:click="handleCoti" class="btn-action"><img src="../assets/images/pro.png"/>Proyeccion de valor</button>
                        </div>
                        <div class="c-user left-info-content">
                          <div class="content-info-parra">
                            <p><small>{{ $t('playerTable.birth_country') }}</small>{{value.nationality}}</p>
                            <p><small>{{ $t('playerTable.passport_country') }}</small>a</p>
                            <p><small>{{ $t('playerTable.height') }}</small>{{value.height}}</p>
                          </div>
                          <div class="content-info-parra">
                            <p><small>{{ $t('playerTable.league') }}</small>{{value.leagueName}}</p>
                            <p><small>{{ $t('playerTable.team') }}</small>{{value.team}}</p>
                            <p><small>{{ $t('playerTable.foot') }}</small>{{value.foot}}</p>
                          </div>
                          <div class="content-info-parra">
                            <p><small>{{ $t('playerTable.position') }}</small>{{value.positions}}</p>
                            <p><small>{{ $t('playerTable.age') }}</small>{{value.ageSet}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="txt-center">
                      </div>
                    </figure>
                    <figure class="media-left">
                      <div class="txt-left iframe-content">
                        <img v-if="value.video == ''" class="image-play-video" src="../assets/images/video_default.png" width='100%'/>
                        <iframe v-else :src="'https://watch.cloudflarestream.com/' + value.video" width='480' height='277' frameborder='0' allow='autoplay; fullscreen' allowfullscreen></iframe>
                        <!--<iframe :src="'https://watch.cloudflarestream.com/' + value.video" width='480' height='277' frameborder='0' allow='autoplay; fullscreen' allowfullscreen></iframe>-->
                      </div>
                    </figure>
                    <div class="info-gral"> 
                      <div class="row">
                        <div class="col-md-12">
                          <h1>{{ $t('playerTable.categories') }}: </h1>
                        </div>
                        <div class="col-md-12 col-lg-4 col-xl-4 not-padding info-u">
                          <p>{{ $t('playerFilter.physical') }}</p>
                          <ul>
                            <li v-for="value in value.skills.physical" :key="value.id">
                              <p v-if="$t('flag.flag') == 'es'">
                                <span v-if="value == 'Pace'">Velocidad </span><span v-else-if="value == 'Velocidad'">Velocidad </span>
                                <span v-if="value == 'Power'">Potencia </span><span v-else-if="value == 'Potencia'">Potencia </span>
                                <span v-if="value == 'Agility'">Agilidad </span><span v-else-if="value == 'Agilidad'">Agilidad </span>
                                <span v-if="value == 'Aerial play'">Juego Aéreo </span><span v-else-if="value == 'Juego Aéreo'">Juego Aéreo </span>
                                <span v-if="value == 'Energy'">Energía </span><span v-else-if="value == 'Energía'">Energía </span>
                              </p>
                              <p v-else>
                                <span v-if="value == 'Velocidad'">Pace </span><span v-else-if="value == 'Pace'">Pace </span>
                                <span v-if="value == 'Potencia'">Power </span><span v-else-if="value == 'Power'">Power </span>
                                <span v-if="value == 'Agilidad'">Agility </span><span v-else-if="value == 'Agility'">Agility </span>
                                <span v-if="value == 'Juego Aéreo'">Aerial Play </span><span v-else-if="value == 'Aerial play'">Aerial Play </span>
                                <span v-if="value == 'Energía'">Energy </span><span v-else-if="value == 'Energy'">Energy </span>
                              </p>
                            </li>
                          </ul>
                        </div>
                        <div class="col-md-12 col-lg-8 col-xl-8 not-padding info-u">
                          <p>{{ $t('playerFilter.technical') }}</p>
                          <ul>
                            <li v-for="value in value.skills.technical" :key="value.id">
                              <p v-if="$t('flag.flag') == 'es'">
                                <span v-if="value == 'Passing'">Pase </span><span v-else-if="value == 'Pase'">Pase </span>
                                <span v-if="value == 'Defending'">Defensa </span><span v-else-if="value == 'Defensa'">Defensa </span>
                                <span v-if="value == 'Dribbling'">Dribbling </span>
                                <span v-if="value == 'Finishing'">Definición </span><span v-else-if="value == 'Definición'">Definición </span>
                                <span v-if="value == 'Awareness'">Intuición </span><span v-else-if="value == 'Intuición'">Intuición </span>
                              </p>
                              <p v-else>
                                <span v-if="value == 'Pase'">Passing </span><span v-else-if="value == 'Passing'">Passing </span>
                                <span v-if="value == 'Defensa'">Defending </span><span v-else-if="value == 'Defending'">Defending </span>
                                <span v-if="value == 'Dribbling'">Dribbling </span>
                                <span v-if="value == 'Definición'">Definición </span><span v-else-if="value == 'Finishing'">Finishing </span>
                                <span v-if="value == 'Intuición'">Awarness </span><span v-else-if="value == 'Awareness'">Awarness </span>
                              </p>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="row contact-as">
                        <div class="col-md-12">
                          <p>{{ $t('playerFilter.technical') }}</p>
                        </div>
                        <div class="col-md-12">
                          <p>{{value.email}}</p>
                        </div>
                      </div>
                    </div>
                  </article>
                </template>
              </div> 
            </td>
          </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import Players from '../parse/models/Players'
import jsonList from "@/assets/data/list.json";
import json from "@/assets/data/sample.json";
import { bus } from "../main";
import WishList from '../parse/models/WishList'


export default {
  name: "lists",
  data() {
    return {
      nameList: this.$t('profile.my_favorites'),
      userName: '',
      role: '',
      team: '',
      list: [],
      data: [],
      contentP: [],
      defaultOpenedDetails: [],
      showDetailIcon: false,
      notification: {
        disable: true,
        id: "",
        name: "",
        message: "",
      },
      selectedUser: null
    };
  },
  components: {},
  beforeMount(){

    WishList.getList().then((wishList) => {
      this.data = wishList
    })   
    
    WishList.playersLists().then((wishList) => {
      this.list = wishList
    })

    //const data = this.$parse.User.current()
    //console.log(data)
    //this.userName = data.fullname
    //this.role = data.position
    //this.team = data.team 
    
    if(localStorage.token){
      this.$parse.User.become(localStorage.token)
      .then((res) => {
        this.userName = res.attributes.fullname
        this.role = res.attributes.position
        this.team = res.attributes.team 
      })
      .catch((error) => {
        console.log(error)
      });
    }
  },
  methods: {
    createList(){

      const notification = {
        disable: false,
        sampleMessage: false,
        message: this.$t('admin.load_player_reel')
      }

      bus.$emit('createList', notification)
    },
    handleRow(index){
      if(this.selectedUser == index){
        this.selectedUser = null;
      } else {
        this.selectedUser = index;
      }
    },

    handleCoti(){
      this.notification = {
        disable: false,
        cotizador: true
      }
      bus.$emit('cotizador', this.notification);
      this.notification = {}
    },

    ageSet(age){
      const age2 = age.split('/').join('.')
      return `'${this.moment(age2, 'DD.MM.YYYY').format("YY")} (${this.getYear(age)})`
    },

    getYear(age){
      const m = this.moment(age, "DD.MM.YYYY");
      const years = this.moment().diff(m, 'years', false);
      return years
    },
    toggle(row) {
      this.$refs.table.toggleDetails(row);
    },
    clean(id, name, index){
      
      this.notification = {
        disable: false,
        sampleMessage: true,
        message: this.$t('notification.player_delete_list')
      }

      this.notificationerror = {
        disable: false,
        sampleMessage: true,
        message: this.$t('notification.error')
      }

      const params = {
        nameList: this.nameList,
        playerId: id
      }

      WishList.removePlayerList(params)
      .then((user) => bus.$emit('sample', this.notification))
      .catch(error => bus.$emit('sample', this.notificationerror))
      
      setTimeout(() => ( this.list.splice(index, 1)), 2000)
    },

    closeAllOtherDetails(row, index) {
      this.defaultOpenedDetails = [row.id];
    },
    handleSelectItem(item) {
      this.data.find((x) => x.id === item).add = true;
      const auxUser = this.data.find((x) => x.id === item);
      const player = auxUser.user.first_name;
      const message = `se ha agregado a tus favoritos`;

      /*this.$buefy.toast.open({
        duration: 5000,
        message: message,
        position: 'is-bottom',
      })
      */
      this.notification = {
        disable: false,
        id: auxUser.id,
        name: player,
        message: message,
      };

      bus.$emit("disable", this.notification);
      this.notification = {};
      this.data = json;
    },
    filterList(name){

      this.nameList = name

      const params = {
        nameList: name
      }

      WishList.playersListsFilter(params).then((wishList) => {   
        this.list = wishList
      })
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.table tr{
  cursor: pointer;
}

.iframe-content{
  width: 480px;
}

.image-play-video{
    width: 100%;
}

.done-row{
  background: #eaeaea;
}


.btn-top-a{
  margin-top: 5%;
}
.name-list{
  text-align: left;
  font-family: "plain medium", arial;
  font-size: 12px;
  margin: 15px;
}

table td, .table th{
  vertical-align: middle;
}

.delete_user {
  width: 25px;
  height: 25px;
  background-color: transparent;
  border: none;
  background: url("../assets/images/delete.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 20px;
}

.in-p-a{
  display: inline;
  text-transform: uppercase;
}

.contact-as{
  margin-top: 5%;
}


/* -- Tables */

.tb-header thead {
  border-bottom: 2px solid #dee2e6;
}

.tb-header thead tr th {
  font-size: 12px;
  color: rgb(138, 138, 138);
}

.table td{
  border: none;
}

.t-border{
  border-bottom: 1px solid #dee2e6;
}

/* -- Tables */




.info-gral{
  width: 100%;
  overflow: hidden;
  text-align: left;
}

.info-gral h1{
  font-family: "plain medium", arial;
  font-weight: 600;
}

.info-u p{
  margin: 10px 0 10px 0;
  color: #aeaeae;
}



.text-left {
  text-align: left;
}
.text-right {
  text-align: left;
}

.info-user h1 {
  font-family: "plain medium", arial;
}

.info-user p {
  font-size: 12px;
}

.not-margin{
  padding: 0;
  margin: 10% 0 0 0;
}

.dropdown-toggle {
  font-size: 13px;
}

.btn-position {
  font-size: 10px;
  border-bottom: 1px solid #000;
  width: 25px;
  padding: 0;
  margin-right: 5px;
  text-transform: uppercase;
  font-family: "plain medium", arial;
}

.dropdown {
  display: inline-block;
  background: #fff;
  color: #000;
  border: 1px solid #000;
  margin-left: 15px;
  margin-right: 5px;
  font-size: 13px;
  font-family: "plain regular", arial;
  height: 35px;
}

.dropdown-menu{
  background: #000;
  color: #fff;
  min-width: 20rem;
  padding: 20px;
  border: 0
}

.dropdown-item, .dropdown .dropdown-menu .has-link a{
  color: #fff;
  font-size: 12px;
  padding: 15px 0 15px 17px;
  opacity: 0.8;
  margin-left: 15px;
}

.principal-option{
  border-bottom: 1px solid;
  opacity: 1;
  margin-left: 0;
}

.principal-option img{
  width: 15px;
  vertical-align: middle;
  margin: 0 10px 3px -15px;
}

a.dropdown-item:hover, .dropdown .dropdown-menu .has-link a:hover, button.dropdown-item:hover {
  background-color: #000;
  color: #fff;
  text-decoration: underline;
}

.l-r {
  border-right: 1px solid rgb(221, 221, 221);
  padding-right: 15px;
}

.txt-left {
  text-align: left;
}

.txt-center {
  text-align: center;
}

.title-name {
  font-family: "plain medium", arial;
  font-size: 12px;
  margin-top: 5px;
}




small {
  margin: 5px 0;
  font-size: 0.775em;
}
.str {
  font-family: "plain medium", arial;
  font-size: 11px;
  text-decoration: underline;
}

.str-n {
  font-family: "plain medium", arial;
  font-size: 11px;
}

.margin-zero {
  margin: 0;
}

.padding-zero {
  padding: 0;
}

.add_player {
  width: 25px;
  height: 25px;
  background-color: transparent;
  border: none !important;
  background: url("../assets/images/active.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 20px;
}

.done {
  width: 25px;
  height: 25px;
  background-color: transparent;
  border: none;
  background: url("../assets/images/active.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 20px;
}

.image-play {
  width: 200px;
  height: 197px;
  object-fit: cover;
}

.form {
  padding: 5%;
  margin: 1% 0 0 0;
  background: #fff;
  border: 1px solid #000;
  height: 250px;
  display: flex;
}

.con-i {
  margin-top: 15px;
}

.form label {
  font-size: 11px;
  width: 120px;
  text-align: right;
  padding-right: 5px;
}

.form input {
  font-size: 12px;
  font-family: "plain medium", arial;
  width: 100px;
  border: 0;
  border-bottom: 1px solid #000;
}

.btn-action {
  border: 1px solid #000;
  background: #fff;
  padding: 5px 15px;
  font-size: 12px;
  margin-top: 5px;
}

.btn-action-create {
  border: 1px solid #000;
  height: 35px;
  border-radius: 0;
  font-size: 13px;
}

.btn-action img {
  width: 20px;
  margin-right: 5px;
}

.left-info-content{
  display: none;
}



/* Mobile first queries */

/* Larger than Desktop HD */
@media (max-width: 1200px) {
  .show-desktop-d{
    display: none;
  }
}

/* Larger than desktop */
@media (max-width: 992px) {

    
    
  .iframe-content{
    width: 100%;
  }


  .not-padding{
    padding: 15px;
  }

  .info-form-contact h1{
    font-size: 16px;
    margin-top: 15px;
  }

  .show-desktop{
    display: none;
  }

  .show-desktop-d{
    display: none;
  }

  .media{
    display: initial;
  }

  .iframe-content{
    margin-top: 10px;
    position: relative;
  }

  .iframe-content iframe{
    width: 100%;
  }

  .action-mobile{
    text-align: left;
  }

  .action-mobile button{
    margin-right: 10px;
  }

  .l-r{
    border-right: none;
    padding: 0;
    margin: 0;
 
  }

  .info-user{
    position: relative;
    overflow: hidden;
  }

  .c-user{
    display: inline-block;
  }
  .c-user img{
    margin: 0 auto;
  }

  .left-info{
    float: left;
  }

  .c-user-right{
    text-align: left;
  }

  .left-info-content{
    float: left;
    text-align: left;
    margin-left: 5%;
    width: 65%;
  }


  small{
    display: block;
    color: #aaa;
  }

  .content-info-parra{
    position: relative;
    width: 100%;
  }

  .content-info-parra p{
    display: inline-block;
    float: left;
    width: 33.3333%;
    height: 70px;
  }
  

}

/* Larger than tablet */
@media (max-width: 768px) {

  .left-info-content{
    width: 55%;
  }

  .content-info-parra p{
    width: 49.9999%;
    font-size: 12px;
  }
  .media-content{
    display: none;
  }
  .iframe-content{
    width: 103%;
  }

  .c-header{
    margin-top: 10%;
  }

}

/* Larger than phablet */
@media (max-width: 550px) {
  .info-form-contact h1{
    font-size: 14px;
  }

  .img-about{
    display: none;
  }
  .con-i input{
    width: 71%;
  }
  .left-info-content{
    width: 46%;
  }
  .left-info{
    text-align: initial;
  }
}

/* Larger than mobile */
@media (max-width: 400px) {
  .left-info-content{
    width: 100%;
    margin-top: 10%;
  }
  .left-info{
    float: initial;
  }
}

</style>
